import { useState, useEffect, useRef, useMemo  } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  getDashboard, getProductsPaginated, getProducts, createProduct, updateProduct, deleteProduct,
  getBanners, createBanner, updateBanner, deleteBanner, toggleBanner,
  getOrders, updateOrderStatus, updateOrder,
  getEnquiries, updateEnquiryStatus, deleteEnquiry,
  getConsignments,validatePromo,
  getBlogs as fetchBlogs, createBlog, updateBlog, deleteBlog,
  getContacts, updateContactStatus,
  getPromoCodes, createPromoCode, deletePromoCode,
  getNewsletterList,
  uploadImage, getLeads,
  getCategories, createCategory, updateCategory, toggleCategoryHome, deleteCategory,
  getAdminFeatured, addFeaturedProduct, removeFeaturedProduct, placeOrder,
  getAdminUsers, createAdminUser, deleteAdminUser, updateAdminUser,
  getClients, createClient, updateClient, deleteClient,
  getBrands, createBrand, updateBrand, deleteBrand,
  getAdminTestimonials, createTestimonial, updateTestimonial,
  toggleTestimonial, deleteTestimonial,deleteOrder,
} from '../lib/api';
import SectionAnalytics from './SectionAnalytics';
import SectionSettings from './SectionSettings';

// const BASE_URL = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
import { BASE_URL, imgSrc } from '../lib/env'

/* ── Responsive hook ── */
function useIsMobile(bp = 768) {
  const [v, setV] = useState(typeof window !== 'undefined' ? window.innerWidth < bp : false);
  useEffect(() => {
    const h = () => setV(window.innerWidth < bp);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [bp]);
  return v;
}

const card  = { background:'#fff', border:'1px solid #e5e7eb', padding:24, borderRadius:2 };
const btn   = (variant='dark') => ({
  padding:'9px 18px', fontSize:11, letterSpacing:'0.15em', textTransform:'uppercase',
  fontWeight:700, border:'none', cursor:'pointer', transition:'all 0.2s',
  background: variant==='dark'?'var(--dark)': variant==='gold'?'var(--gold)': variant==='red'?'#ef4444':'transparent',
  color: variant==='ghost'?'var(--grey-dark)':'#fff',
  ...(variant==='ghost' ? { border:'1px solid var(--grey)' } : {}),
});
const inp   = { width:'100%', border:'1px solid #e5e7eb', padding:'10px 12px', fontSize:12, outline:'none', fontFamily:'var(--font-body)', color:'var(--dark)', background:'#fafafa', boxSizing:'border-box', transition:'border-color 0.2s' };
const th    = { fontSize:10, letterSpacing:'0.15em', textTransform:'uppercase', fontWeight:700, color:'var(--grey-dark)', padding:'12px 16px', borderBottom:'2px solid var(--grey)', textAlign:'left', whiteSpace:'nowrap' };
const td    = { fontSize:12, color:'var(--dark)', padding:'12px 16px', borderBottom:'1px solid var(--grey-light)', verticalAlign:'middle' };
const label = { fontSize:10, letterSpacing:'0.12em', textTransform:'uppercase', fontWeight:700, color:'var(--grey-dark)', display:'block', marginBottom:6 };

// const NAV_ITEMS = [
//   { key:'dashboard',    icon:'📊', label:'Dashboard'   },
//   { key:'analytics',    icon:'📈', label:'Analytics'   },
//   { key:'products',     icon:'👜', label:'Products'    },
//   { key:'orders',       icon:'📦', label:'Orders'      },
//   { key:'brands',       icon:'🛍️',  label:'Brands'      },
//   { key:'banners',      icon:'🎯',  label:'Banners'     },
//   { key:'categories',   icon:'📚',  label:'Categories'  },
//   { key:'featured',     icon:'⭐', label:'Featured'    },
//   { key:'clients',      icon:'👥', label:'Clients'     },
//   { key:'enquiries',    icon:'💬', label:'Enquiries'   },
//   { key:'consignments', icon:'📋', label:'Sell Products'},
//   { key:'promo',        icon:'🏷',  label:'Promo Codes' },
//   { key:'newsletter',   icon:'📧', label:'Newsletter'  },
//   { key:'leads', icon:'🎯', label:'Leads' },
//   { key:'testimonials', icon:'⭐', label:'Testimonials'},
//   { key:'users',        icon:'👤', label:'Users'       },
//   { key:'settings',     icon:'⚙️', label:'Settings'    },
// ];

const NAV_ICONS = {
  dashboard: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  analytics: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
  products: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>
  ),
  orders: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  brands: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"/>
      <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/>
    </svg>
  ),
  banners: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
    </svg>
  ),
  categories: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
    </svg>
  ),
  featured: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  clients: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  ),
  enquiries: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  ),
  consignments: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/>
      <line x1="10" y1="12" x2="14" y2="12"/>
    </svg>
  ),
  promo: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
      <line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  ),
  newsletter: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  leads: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  testimonials: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/>
    </svg>
  ),
  users: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  settings: (
    <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
};

const NAV_ITEMS = [
  { key:'dashboard',    label:'Dashboard'    },
  { key:'analytics',    label:'Analytics'    },
  { key:'brands',       label:'Brands'       },
  { key:'categories',   label:'Categories'   },
  { key:'products',     label:'Products'     },
  { key:'orders',       label:'Orders'       },
  { key:'banners',      label:'Banners'      },
  { key:'featured',     label:'Featured'     },
  { key:'clients',      label:'Clients'      },
  { key:'enquiries',    label:'Enquiries'    },
  { key:'consignments', label:'Sell Products'},
  { key:'promo',        label:'Promo Codes'  },
  { key:'newsletter',   label:'Newsletter'   },
  { key:'leads',        label:'Leads'        },
  { key:'testimonials', label:'Testimonials' },
  { key:'users',        label:'Users'        },
  { key:'settings',     label:'Settings'     },
];

/* ─── Main AdminPanel ─────────────────────────── */
export default function AdminPanel() {
  // const { isAuthenticated, logout, email } = useAuth();
  const { isAuthenticated, logout, email, loading } = useAuth();

  const navigate = useNavigate();
  const [section, setSection] = useState('dashboard');
  const isMobile = useIsMobile();

  // Desktop: sidebar open by default; Mobile: closed by default
  const [sideOpen, setSideOpen] = useState(!isMobile);

  // On resize, auto-close sidebar when going mobile
  useEffect(() => { if (isMobile) setSideOpen(false); }, [isMobile]);

  // useEffect(() => { if (!isAuthenticated) navigate('/admin/login'); }, [isAuthenticated, navigate]);
  useEffect(() => { 
    if (!loading && !isAuthenticated) navigate('/admin/login'); 
  }, [isAuthenticated, loading, navigate]);
  if (loading) return (
  <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f8f9fa' }}>
    <div style={{ fontSize:12, color:'var(--grey-mid)', letterSpacing:'0.1em' }}>Loading…</div>
  </div>
);
  if (!isAuthenticated) return null;

  function handleNavClick(key) {
    setSection(key);
    if (isMobile) setSideOpen(false); // auto-close on mobile after tap
  }

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#f8f9fa', fontFamily:'var(--font-body)', position:'relative' }}>

      {/* ── Mobile overlay backdrop ── */}
      {isMobile && sideOpen && (
        <div
          onClick={() => setSideOpen(false)}
          style={{
            position:'fixed', inset:0, background:'rgba(0,0,0,0.5)',
            zIndex:40,
          }}
        />
      )}

      {/* ── Sidebar ── */}
      <aside style={{
        width: sideOpen ? 220 : (isMobile ? 0 : 64),
        flexShrink: 0,
        background:'var(--dark)',
        display:'flex', flexDirection:'column',
        transition:'width 0.25s ease',
        overflow:'hidden',
        // On mobile: fixed overlay; on desktop: sticky in flow
        // position: isMobile ? 'fixed' : 'sticky',
         position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        // zIndex: isMobile ? 50 : 'auto',
        zIndex: isMobile ? 50 : 20,
      }}>
        {/* Logo */}
        <div style={{ padding:'20px 16px', borderBottom:'1px solid rgba(255,255,255,0.08)', display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
          <div style={{ width:32, height:32, borderRadius:'50%', background:'var(--gold)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <span style={{ color:'#fff', fontSize:14, fontFamily:'var(--font-display)', fontWeight:300 }}>A</span>
          </div>
          {sideOpen && (
            <div>
              <div style={{ fontSize:12, fontWeight:600, color:'#fff', letterSpacing:'0.1em', textTransform:'uppercase', whiteSpace:'nowrap' }}>Aurora</div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.35)', letterSpacing:'0.15em', textTransform:'uppercase' }}>Admin</div>
            </div>
          )}
        </div>

        {/* Toggle button — hidden on mobile (use hamburger in topbar instead) */}
        {!isMobile && (
          <button
            onClick={() => setSideOpen(v => !v)}
            style={{ background:'none', border:'none', cursor:'pointer', padding:'12px 16px', color:'rgba(255,255,255,0.35)', textAlign:'left', fontSize:16, flexShrink:0 }}>
            {sideOpen ? '◀' : '▶'}
          </button>
        )}

        {/* Nav */}
        <nav style={{ flex:1, padding:'8px 0', overflowY:'auto' }}>
          {/* {NAV_ITEMS.map(({ key, icon, label: lbl }) => (
            <button key={key} onClick={() => handleNavClick(key)} style={{
              width:'100%', display:'flex', alignItems:'center', gap:14,
              padding:'12px 16px', background: section===key ? 'rgba(201,168,76,0.15)' : 'none',
              border:'none', cursor:'pointer', textAlign:'left',
              borderLeft: section===key ? '3px solid var(--gold)' : '3px solid transparent',
              transition:'all 0.2s',
            }}
            >
              <span style={{ fontSize:18, flexShrink:0 }}>{icon}</span>
              {sideOpen && (
                <span style={{
                  fontSize:12, fontWeight:500,
                  color: section===key ? 'var(--gold)' : 'rgba(255,255,255,0.6)',
                  letterSpacing:'0.05em', whiteSpace:'nowrap',
                }}>
                  {lbl}
                </span>
              )}
            </button>
          ))} */}
          {NAV_ITEMS.map(({ key, label: lbl }) => (
  <button key={key} onClick={() => handleNavClick(key)} style={{
    width:'100%', display:'flex', alignItems:'center', gap:14,
    padding:'12px 16px', background: section===key ? 'rgba(201,168,76,0.15)' : 'none',
    border:'none', cursor:'pointer', textAlign:'left',
    borderLeft: section===key ? '3px solid var(--gold)' : '3px solid transparent',
    transition:'all 0.2s',
  }}
  onMouseEnter={e => {
    if (section !== key) e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
    const span = e.currentTarget.querySelector('span.nav-label');
    if (span && section !== key) span.style.color = '#fff';
    const svg = e.currentTarget.querySelector('svg');
    if (svg && section !== key) svg.style.stroke = '#fff';
  }}
  onMouseLeave={e => {
    if (section !== key) e.currentTarget.style.background = 'none';
    const span = e.currentTarget.querySelector('span.nav-label');
    if (span && section !== key) span.style.color = 'rgba(255,255,255,0.5)';
    const svg = e.currentTarget.querySelector('svg');
    if (svg && section !== key) svg.style.stroke = 'rgba(255,255,255,0.5)';
  }}>
    <span style={{
      flexShrink:0,
      color: section===key ? 'var(--gold)' : 'rgba(255,255,255,0.5)',
      display:'flex', alignItems:'center',
      transition:'color 0.2s',
    }}>
      {NAV_ICONS[key]}
    </span>
    {sideOpen && (
      <span className="nav-label" style={{
        fontSize:12, fontWeight:500,
        color: section===key ? 'var(--gold)' : 'rgba(255,255,255,0.5)',
        letterSpacing:'0.05em', whiteSpace:'nowrap',
        transition:'color 0.2s',
      }}>
        {lbl}
      </span>
    )}
  </button>
))}
        </nav>

        {/* User */}
        {/* <div style={{ padding:16, borderTop:'1px solid rgba(255,255,255,0.08)', flexShrink:0 }}>
          {sideOpen && (
            <div style={{ fontSize:11, color:'rgba(255,255,255,0.35)', marginBottom:10, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {email}
            </div>
          )}
          <button
            onClick={() => { logout(); navigate('/admin/login'); }}
            style={{
              width:'100%', padding:'8px 12px', background:'rgba(239,68,68,0.15)',
              border:'1px solid rgba(239,68,68,0.3)', color:'#f87171',
              fontSize:10, letterSpacing:'0.1em', textTransform:'uppercase',
              fontWeight:600, cursor:'pointer', transition:'all 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.25)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.15)'}>
            {sideOpen ? 'Sign Out' : '↩'}
          </button>
        </div> */}
        {/* User */}
<div style={{ padding:16, borderTop:'1px solid rgba(255,255,255,0.08)', flexShrink:0 }}>
  {sideOpen && (
    <div style={{ fontSize:11, color:'rgba(255,255,255,0.35)', marginBottom:10, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
      {email}
    </div>
  )}
  <button
    onClick={() => { logout(); navigate('/admin/login'); }}
    style={{
      width:'100%', padding:'8px 12px', background:'rgba(239,68,68,0.15)',
      border:'1px solid rgba(239,68,68,0.3)', color:'#f87171',
      fontSize:10, letterSpacing:'0.1em', textTransform:'uppercase',
      fontWeight:600, cursor:'pointer', transition:'all 0.2s',
    }}
    onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.25)'}
    onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.15)'}>
    {/* {sideOpen ? 'Sign Out' : '↩'}   ← THIS is the problem on mobile */}
    {sideOpen || isMobile ? 'Sign Out' : '↩'}
  </button>
</div>
      </aside>

      {/* ── Main ── */}
      <main style={{
        flex:1,
        overflow:'auto',
        // On mobile, sidebar is overlay so main takes full width
        // marginLeft: isMobile ? 0 : 0,
        marginLeft: isMobile ? 0 : (sideOpen ? 220 : 64),
        transition: 'margin-left 0.25s ease',
        minWidth: 0,
      }}>
        {/* Top bar */}
        <div style={{
          background:'#fff', borderBottom:'1px solid #e5e7eb',
          padding: isMobile ? '14px 16px' : '16px 32px',
          display:'flex', alignItems:'center', justifyContent:'space-between',
          position:'sticky', top:0, zIndex:10, gap:12,
        }}>
          {/* Hamburger on mobile */}
          {isMobile && (
            <button
              onClick={() => setSideOpen(v => !v)}
              style={{
                background:'none', border:'none', cursor:'pointer',
                padding:'6px', display:'flex', flexDirection:'column',
                gap:4, flexShrink:0,
              }}>
              {[0,1,2].map(i => (
                <div key={i} style={{ width:20, height:2, background:'var(--dark)', borderRadius:1 }} />
              ))}
            </button>
          )}

          <h1 style={{
            fontSize: isMobile ? 14 : 16,
            fontWeight:600, color:'var(--dark)', letterSpacing:'0.05em',
            margin:0, flex:1,
          }}>
            {NAV_ITEMS.find(n => n.key === section)?.label}
          </h1>

          <div style={{ fontSize: isMobile ? 10 : 12, color:'var(--grey-mid)', whiteSpace:'nowrap' }}>
            {new Date().toLocaleDateString('en-IN', {
              weekday: isMobile ? undefined : 'long',
              year:'numeric', month: isMobile ? 'short' : 'long', day:'numeric',
            })}
          </div>
        </div>

        {/* Section content */}
        <div style={{ padding: isMobile ? '16px' : '32px' }}>
          {/* {section==='dashboard'    && <SectionDashboard />} */}
          {section==='dashboard' && <SectionDashboard onSectionChange={setSection} />}
          {section==='analytics'    && <SectionAnalytics />}
          {section==='products'     && <SectionProducts />}
          {section==='brands'       && <SectionBrands />}
          {section==='banners'      && <SectionBanners />}
          {section==='categories'   && <SectionCategories />}
          {section==='featured'     && <SectionFeatured />}
          {section==='orders'       && <SectionOrders />}
          {section==='clients'      && <SectionClients />}
          {section==='enquiries'    && <SectionEnquiries />}
          {section==='consignments' && <SectionConsignments />}
          {section==='blogs'        && <SectionBlogs />}
          {section==='contacts'     && <SectionContacts />}
          {section==='promo'        && <SectionPromo />}
          {section==='newsletter'   && <SectionNewsletter />}
          {section === 'leads' && <SectionLeads />}
          {section==='testimonials' && <SectionTestimonials />}
          {section==='users'        && <SectionUsers />}
          {section==='settings'     && <SectionSettings />}
        </div>
      </main>
    </div>
  );
}

/* ─── Dashboard ──────────────────────────────── */

function SectionDashboard({ onSectionChange }) {
  const [data, setData] = useState(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    getDashboard().then(setData).catch(() => {});
  }, []);

  const stats = data ? [
    {
      label: 'Total Revenue',
      value: '₹' + (data.revenue ?? 0).toLocaleString('en-IN'),
      sub: 'all time',
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
          <path d="M12 6v2m0 8v2M9 12h6"/>
        </svg>
      ),
    },
    {
      label: 'Active Orders',
      value: data.orders ?? 0,
      sub: `${data.pending ?? 0} to fulfill`,
      subColor: '#f59e0b',
      section: 'orders',
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        </svg>
      ),
    },
    {
      label: 'Products in Stock',
      value: data.in_stock ?? data.products ?? 0,
      sub: `${data.products ?? 0} in catalogue`,
      section: 'products',
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
          <line x1="7" y1="7" x2="7.01" y2="7"/>
        </svg>
      ),
    },
    {
      label: 'Total Orders',
      value: data.total_orders ?? data.orders ?? 0,
      sub: `${data.delivered ?? 0} delivered`,
      section: 'orders',
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <rect x="5" y="2" width="14" height="20" rx="2"/>
          <path d="M9 7h6M9 11h6M9 15h4"/>
        </svg>
      ),
    },
  ] : Array.from({ length: 4 }).map(() => ({ label: 'Loading…', value: '—', sub: '', icon: null }));

  const STATUS_COLOR = {
    delivered:  { bg: '#dcfce7', color: '#16a34a' },
    processing: { bg: '#fef9c3', color: '#ca8a04' },
    shipped:    { bg: '#dbeafe', color: '#2563eb' },
    cancelled:  { bg: '#fee2e2', color: '#dc2626' },
    pending:    { bg: '#fef3c7', color: '#d97706' },
    confirmed:  { bg: '#dbeafe', color: '#1d4ed8' },
  };

  const conciergeActions = [
    {
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
      title: 'View Enquiries',
      sub: `${data?.enquiries ?? 0} pending`,
      section: 'enquiries',
      color: '#f59e0b',
    },
    {
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        </svg>
      ),
      title: 'View Orders',
      sub: `${data?.orders ?? 0} total orders`,
      section: 'orders',
      color: '#3b82f6',
    },
    {
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <polyline points="21 8 21 21 3 21 3 8"/>
          <rect x="1" y="3" width="22" height="5"/>
          <line x1="10" y1="12" x2="14" y2="12"/>
        </svg>
      ),
      title: 'Sell Products',
      sub: 'Review submissions',
      section: 'consignments',
      color: '#8b5cf6',
    },
    {
      icon: (
        <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      ),
      title: 'Newsletter',
      sub: 'Manage subscribers',
      section: 'newsletter',
      color: '#10b981',
    },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 20 : 32 }}>

      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
        <div>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: isMobile ? 'clamp(28px,7vw,40px)' : 'clamp(36px,5vw,52px)',
            fontWeight: 300, color: 'var(--dark)', letterSpacing: '-0.02em', lineHeight: 1.1, margin: 0,
          }}>
            Dashboard
          </h1>
          <p style={{ fontSize: 13, color: 'var(--grey-mid)', marginTop: 6, fontFamily: 'var(--font-body)' }}>
            Here's what's happening at the House today.
          </p>
        </div>
        {!isMobile && (
          <button
            onClick={() => {
              const rows = (data?.recent_orders || []).map(o =>
                [o.ref || o.order_ref, o.customer_name, o.total, o.status, o.created_at].join(',')
              );
              const csv = ['Order,Client,Total,Status,Date', ...rows].join('\n');
              const a = document.createElement('a');
              a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
              a.download = 'aurora-orders.csv';
              a.click();
            }}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '10px 20px', background: '#fff',
              border: '1px solid #e5e7eb', cursor: 'pointer',
              fontSize: 12, fontWeight: 600, color: 'var(--dark)',
              fontFamily: 'var(--font-body)', letterSpacing: '0.05em',
              transition: 'border-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--dark)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#e5e7eb'}>
            <svg width={15} height={15} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7,10 12,15 17,10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Export CSV
          </button>
        )}
      </div>

      {/* ── Stat Cards ── */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
        gap: isMobile ? 10 : 16,
      }}>
        {stats.map((s, i) => (
          <div
            key={i}
            onClick={() => s.section && onSectionChange(s.section)}
            style={{
              background: '#fff', border: '1px solid #e8e4de', borderRadius: 12,
              padding: isMobile ? '16px 14px' : '24px 22px',
              display: 'flex', flexDirection: 'column', gap: isMobile ? 8 : 12,
              cursor: s.section ? 'pointer' : 'default',
              transition: 'box-shadow 0.2s, transform 0.2s',
            }}
            onMouseEnter={e => { if (s.section) { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: isMobile ? 9 : 10, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, color: 'var(--grey-mid)', fontFamily: 'var(--font-body)' }}>
                {s.label}
              </div>
              {!isMobile && (
                <div style={{ color: 'var(--grey-mid)', opacity: 0.5 }}>{s.icon}</div>
              )}
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: isMobile ? 'clamp(18px,5vw,28px)' : 'clamp(24px,3vw,36px)', fontWeight: 300, color: 'var(--dark)', lineHeight: 1 }}>
              {s.value}
            </div>
            {s.sub && (
              <div style={{
                fontSize: 11, color: s.subColor || 'var(--grey-mid)', fontFamily: 'var(--font-body)',
                ...(s.subColor ? { background: s.subColor + '18', padding: '2px 8px', borderRadius: 20, width: 'fit-content', fontWeight: 600 } : {}),
              }}>
                {s.sub}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ── Bottom Row ── */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 380px',
        gap: isMobile ? 16 : 24,
        alignItems: 'start',
      }}>

        {/* Recent Orders */}
        <div style={{ background: '#fff', border: '1px solid #e8e4de', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? '16px' : '20px 24px', borderBottom: '1px solid #f3f0eb' }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 300, color: 'var(--dark)', margin: 0 }}>
              Recent Orders
            </h2>
            <button
              onClick={() => onSectionChange('orders')}
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: 'var(--gold)', fontWeight: 600, fontFamily: 'var(--font-body)' }}>
              View All →
            </button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: isMobile ? 500 : 'auto' }}>
              <thead>
                <tr style={{ background: '#faf8f5' }}>
                  {['Order', 'Client', 'Date', 'Status', 'Total'].map(h => (
                    <th key={h} style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600, color: 'var(--grey-mid)', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #f3f0eb', fontFamily: 'var(--font-body)', whiteSpace: 'nowrap' }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(data?.recent_orders || []).slice(0, 6).map(o => {
                  const sc = STATUS_COLOR[(o.status || '').toLowerCase()] || { bg: '#f3f4f6', color: '#6b7280' };
                  return (
                    <tr
                      key={o.id || o.order_ref}
                      onClick={() => onSectionChange('orders')}
                      style={{ borderBottom: '1px solid #f9f7f4', transition: 'background 0.15s', cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#faf8f5'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <td style={{ padding: '14px 16px' }}>
                        <span style={{ fontFamily: 'var(--font-display)', fontSize: 14, fontWeight: 400, color: 'var(--dark)' }}>
                          #{(o.ref || o.order_ref || '').replace('ORD-', 'ALI-')}
                        </span>
                      </td>
                      <td style={{ padding: '14px 16px', fontSize: 12, color: 'var(--dark)' }}>{o.customer_name}</td>
                      <td style={{ padding: '14px 16px', fontSize: 11, color: 'var(--grey-mid)', whiteSpace: 'nowrap' }}>
                        {o.created_at ? new Date(o.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }) : '—'}
                      </td>
                      <td style={{ padding: '14px 16px' }}>
                        <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20, background: sc.bg, color: sc.color }}>
                          {o.status ? o.status.charAt(0).toUpperCase() + o.status.slice(1) : '—'}
                        </span>
                      </td>
                      <td style={{ padding: '14px 16px', fontSize: 13, fontWeight: 500, color: 'var(--dark)', whiteSpace: 'nowrap' }}>
                        ₹{Number(o.total).toLocaleString('en-IN')}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {(!data || !data.recent_orders?.length) && (
              <p style={{ padding: '32px 24px', fontSize: 12, color: 'var(--grey-mid)', textAlign: 'center' }}>
                No orders yet.
              </p>
            )}
          </div>
        </div>

        {/* Concierge Actions */}
        <div style={{ background: '#fff', border: '1px solid #e8e4de', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: isMobile ? '16px' : '20px 24px', borderBottom: '1px solid #f3f0eb' }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 300, color: 'var(--dark)', margin: 0 }}>
              Concierge Actions
            </h2>
          </div>
          <div style={{ padding: '8px 0' }}>
            {conciergeActions.map((item, i) => (
              <div
                key={item.title}
                onClick={() => onSectionChange(item.section)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 16,
                  padding: isMobile ? '14px 16px' : '18px 24px',
                  cursor: 'pointer', transition: 'background 0.15s',
                  borderTop: i > 0 ? '1px solid #f3f0eb' : 'none',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#faf8f5'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <div style={{
                  width: 44, height: 44, borderRadius: '50%',
                  background: item.color + '18',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0, color: item.color,
                }}>
                  {item.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--dark)', fontFamily: 'var(--font-body)', marginBottom: 2 }}>
                    {item.title}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--grey-mid)', fontFamily: 'var(--font-body)' }}>
                    {item.sub}
                  </div>
                </div>
                <svg width={14} height={14} fill="none" stroke="var(--grey-mid)" strokeWidth={2} viewBox="0 0 24 24">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

/* ─── Products ───────────────────────────────── */

function SectionProducts() {
  const [products, setProducts]       = useState([]);
  const [editing,  setEditing]        = useState(null);
  const [showForm, setShowForm]       = useState(false);
  const [search,   setSearch]         = useState('');
  const [filterCat,   setFilterCat]   = useState('all');
  const [filterBrand, setFilterBrand] = useState('all');
  const [filterStock, setFilterStock] = useState('all');
  const [page,        setPage]        = useState(1);
  const [totalPages,  setTotalPages]  = useState(1);
  const [totalCount,  setTotalCount]  = useState(0);
  const [LIMIT, setLimitState]        = useState(10);
  const [allBrands, setAllBrands]     = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const isMobile = useIsMobile();

  // load brands + categories for filter dropdowns once
  useEffect(() => {
    getBrands().then(d => setAllBrands(Array.isArray(d) ? d : [])).catch(() => {});
    getCategories().then(d => setAllCategories(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  // function loadProducts(p = 1, limit = LIMIT) {
  //   const filters = {};
  //   if (search)                   filters.search   = search;
  //   if (filterCat   !== 'all')    filters.category = filterCat;
  //   if (filterBrand !== 'all')    filters.brand    = filterBrand;
  //   if (filterStock !== 'all')    filters.stock    = filterStock;

  //   getProducts(p, limit, filters).then(d => {
  //     if (Array.isArray(d)) {
  //       // fallback: no pagination wrapper
  //       setProducts(d);
  //       setPage(1); setTotalPages(1); setTotalCount(d.length);
  //     } else {
  //       setProducts(d.products || []);
  //       setPage(d.page || p);
  //       setTotalPages(d.total_pages || 1);
  //       setTotalCount(d.total || 0);
  //     }
  //   }).catch(() => {});
  // }

  // reload when filters or limit change
  
  function loadProducts(p = 1, limit = LIMIT) {
  const filters = {};
  if (search)                 filters.search   = search;
  if (filterCat   !== 'all') filters.category = filterCat;
  if (filterBrand !== 'all') filters.brand    = filterBrand;
  if (filterStock !== 'all') filters.stock    = filterStock;

  getProductsPaginated(p, limit, filters).then(d => {   // ← changed
    if (Array.isArray(d)) {
      setProducts(d);
      setPage(1); setTotalPages(1); setTotalCount(d.length);
    } else {
      setProducts(d.products || []);
      setPage(d.page || p);
      setTotalPages(d.total_pages || 1);
      setTotalCount(d.total || 0);
    }
  }).catch(() => {});
}

  useEffect(() => { loadProducts(1, LIMIT); }, [search, filterCat, filterBrand, filterStock, LIMIT]);

  function openNew()   { setEditing(null); setShowForm(true); }
  function openEdit(p) { setEditing(p);    setShowForm(true); }
  function closeForm() { setEditing(null); setShowForm(false); }

  async function onSave(data) {
    if (editing) {
      await updateProduct(editing.id, data);
    } else {
      await createProduct(data);
    }
    loadProducts(page, LIMIT);
    closeForm();
  }

  async function onDelete(id) {
    if (!window.confirm('Delete this product?')) return;
    await deleteProduct(id);
    loadProducts(page, LIMIT);
  }

  if (showForm) return <ProductForm initial={editing} onSave={onSave} onCancel={closeForm} />;

  const selStyle = { border:'1px solid #e5e7eb', padding:'8px 12px', fontSize:11, background:'#fff', color:'var(--dark)', outline:'none', cursor:'pointer', fontFamily:'var(--font-body)' };
  const activeFilters = [filterCat, filterBrand, filterStock].filter(f => f !== 'all').length + (search ? 1 : 0);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      {/* Top bar */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, flexWrap:'wrap' }}>
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', flex:1 }}>
          <input value={search} onChange={e => { setSearch(e.target.value); }}
            placeholder="Search…"
            style={{ ...inp, maxWidth: isMobile ? '100%' : 240, flex: isMobile ? 1 : 'none' }}
            onFocus={e => e.target.style.borderColor='var(--dark)'}
            onBlur={e => e.target.style.borderColor='#e5e7eb'} />
          {!isMobile && (
            <>
              <select value={filterCat} onChange={e => setFilterCat(e.target.value)} style={selStyle}>
                <option value="all">All Categories</option>
                {allCategories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
              </select>
              <select value={filterBrand} onChange={e => setFilterBrand(e.target.value)} style={selStyle}>
                <option value="all">All Brands</option>
                {allBrands.map(b => <option key={b.id} value={b.name}>{b.name}</option>)}
              </select>
              <select value={filterStock} onChange={e => setFilterStock(e.target.value)} style={selStyle}>
                <option value="all">All Stock</option>
                <option value="instock">In Stock</option>
                <option value="low">Low Stock (≤3)</option>
                <option value="soldout">Sold Out</option>
              </select>
            </>
          )}
          {activeFilters > 0 && (
            <button onClick={() => { setFilterCat('all'); setFilterBrand('all'); setFilterStock('all'); setSearch(''); }}
              style={{ fontSize:11, color:'var(--red)', background:'none', border:'none', cursor:'pointer', fontWeight:600, padding:0 }}>
              ✕ Clear ({activeFilters})
            </button>
          )}
        </div>
        <button onClick={openNew} style={btn('gold')}>+ Add Product</button>
      </div>

      <p style={{ fontSize:11, color:'var(--grey-mid)', margin:0 }}>
        Showing <strong>{(page-1)*LIMIT+1}</strong>–<strong>{Math.min(page*LIMIT, totalCount)}</strong> of <strong>{totalCount}</strong> products
      </p>

      <div style={card}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:700 }}>
            <thead>
              <tr>{['Image','SKU','Brand / Name','Category','Price','Stock','Visibility','Actions'].map(h=><th key={h} style={th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {products.map(p=>(
                <tr key={p.id} style={{ transition:'background 0.15s' }} onMouseEnter={e=>e.currentTarget.style.background='#f8f9fa'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <td style={td}>{imgSrc(p.img)?<img src={imgSrc(p.img)} alt="" style={{ width:48,height:56,objectFit:'cover' }}/>:<div style={{ width:48,height:56,background:'var(--grey-light)',display:'flex',alignItems:'center',justifyContent:'center' }}>👜</div>}</td>
                  <td style={td}><code style={{ fontSize:10,background:'#f3f4f6',padding:'2px 6px',color:'var(--grey-dark)' }}>{p.sku||`SKU-${String(p.id).padStart(5,'0')}`}</code></td>
                  <td style={td}><div style={{ fontSize:10,color:'var(--grey-mid)',textTransform:'uppercase' }}>{p.brand}</div><div style={{ fontWeight:500 }}>{p.name}</div></td>
                  <td style={td}>{p.category||'—'}</td>
                  <td style={td}><div>₹{Number(p.price||0).toLocaleString('en-IN')}</div>{p.was&&<div style={{ fontSize:11,color:'var(--grey-mid)',textDecoration:'line-through' }}>₹{Number(p.was).toLocaleString('en-IN')}</div>}</td>
                  <td style={td}><span style={{ fontSize:11,fontWeight:700,padding:'3px 8px',background:Number(p.stock)===0?'#fee2e2':Number(p.stock)<=3?'#fff7ed':'#dcfce7',color:Number(p.stock)===0?'#dc2626':Number(p.stock)<=3?'#c2410c':'#16a34a' }}>{Number(p.stock)===0?'Sold Out':`${p.stock} left`}</span></td>
                  {/* <td style={td}>
                    <button
                      onClick={async () => {
                        await updateProduct(p.id, { show_home: p.show_home ? 0 : 1 });
                        loadProducts(page, LIMIT);
                      }}
                      style={{
                        padding: '4px 10px',
                        fontSize: 10,
                        fontWeight: 700,
                        border: 'none',
                        cursor: 'pointer',
                        background: p.show_home ? '#dcfce7' : '#fee2e2',
                        color: p.show_home ? '#16a34a' : '#dc2626',
                        letterSpacing: '0.05em',
                      }}
                    >
                      {p.show_home ? 'Visible' : 'Hidden'}
                    </button>
                  </td> */}
                  <td style={td}>
                    <div
                      onClick={async () => {
                        await updateProduct(p.id, { show_home: p.show_home ? 0 : 1 });
                        loadProducts(page, LIMIT);
                      }}
                      title={p.show_home ? 'Click to Hide' : 'Click to Show'}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 4,
                        cursor: 'pointer',
                        userSelect: 'none',
                      }}
                    >
                      {/* Toggle Track */}
                      <div style={{
                        width: 44,
                        height: 24,
                        borderRadius: 12,
                        background: p.show_home ? '#16a34a' : '#d1d5db',
                        position: 'relative',
                        transition: 'background 0.25s ease',
                        flexShrink: 0,
                      }}>
                        {/* Toggle Thumb */}
                        <div style={{
                          position: 'absolute',
                          top: 3,
                          left: p.show_home ? 23 : 3,
                          width: 18,
                          height: 18,
                          borderRadius: '50%',
                          background: '#fff',
                          boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                          transition: 'left 0.25s ease',
                        }} />
                      </div>
                      {/* Label */}
                      <span style={{
                        fontSize: 9,
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        color: p.show_home ? '#16a34a' : '#9ca3af',
                        textTransform: 'uppercase',
                      }}>
                        {p.show_home ? 'Visible' : 'Hidden'}
                      </span>
                    </div>
                  </td>
                  <td style={td}><div style={{ display:'flex',gap:8 }}><button onClick={()=>openEdit(p)} style={{ padding:'6px 12px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>Edit</button><button onClick={()=>onDelete(p.id)} style={{ padding:'6px 12px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Del</button></div></td>
                </tr>
              ))}
              {products.length===0&&<tr><td colSpan="7" style={{ textAlign:'center',padding:40,fontSize:12,color:'var(--grey-mid)' }}>No products match your filters.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {totalCount > 0 && (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
            <p style={{ fontSize:12, color:'var(--grey-mid)', margin:0 }}>
              Page <strong>{page}</strong> of <strong>{totalPages}</strong>
            </p>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:11, color:'var(--grey-mid)', whiteSpace:'nowrap' }}>Rows per page:</span>
              <select value={LIMIT} onChange={e => { setLimitState(Number(e.target.value)); }}
                style={{ border:'1px solid #e5e7eb', padding:'6px 10px', fontSize:12, background:'#fff', color:'var(--dark)', outline:'none', cursor:'pointer', fontFamily:'var(--font-body)', borderRadius:4 }}>
                {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>

          {totalPages > 1 && (
            <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
              <button onClick={() => loadProducts(page - 1, LIMIT)} disabled={page <= 1}
                style={{ width:34, height:34, display:'flex', alignItems:'center', justifyContent:'center', border:'1px solid #e5e7eb', background: page<=1?'#f3f4f6':'#fff', color: page<=1?'#9ca3af':'var(--dark)', cursor: page<=1?'not-allowed':'pointer', fontSize:14, borderRadius:4, fontWeight:600 }}>
                ‹
              </button>
              {(() => {
                const half = 2, start = Math.max(1, page-half), end = Math.min(totalPages, start+4);
                const pages = [];
                if (start > 1) { pages.push(<button key={1} onClick={() => loadProducts(1, LIMIT)} style={{ width:34,height:34,display:'flex',alignItems:'center',justifyContent:'center',border:'1px solid #e5e7eb',background:'#fff',color:'var(--dark)',cursor:'pointer',fontSize:12,borderRadius:4 }}>1</button>); if (start > 2) pages.push(<span key="l" style={{ padding:'0 4px', color:'var(--grey-mid)' }}>…</span>); }
                for (let p = start; p <= end; p++) {
                  const active = p === page;
                  pages.push(<button key={p} onClick={() => loadProducts(p, LIMIT)} style={{ width:34,height:34,display:'flex',alignItems:'center',justifyContent:'center',border:`1px solid ${active?'var(--dark)':'#e5e7eb'}`,background:active?'var(--dark)':'#fff',color:active?'#fff':'var(--dark)',cursor:'pointer',fontSize:12,fontWeight:active?700:400,borderRadius:4 }}>{p}</button>);
                }
                if (end < totalPages) { if (end < totalPages-1) pages.push(<span key="r" style={{ padding:'0 4px', color:'var(--grey-mid)' }}>…</span>); pages.push(<button key={totalPages} onClick={() => loadProducts(totalPages, LIMIT)} style={{ width:34,height:34,display:'flex',alignItems:'center',justifyContent:'center',border:'1px solid #e5e7eb',background:'#fff',color:'var(--dark)',cursor:'pointer',fontSize:12,borderRadius:4 }}>{totalPages}</button>); }
                return pages;
              })()}
              <button onClick={() => loadProducts(page + 1, LIMIT)} disabled={page >= totalPages}
                style={{ width:34, height:34, display:'flex', alignItems:'center', justifyContent:'center', border:'1px solid #e5e7eb', background: page>=totalPages?'#f3f4f6':'#fff', color: page>=totalPages?'#9ca3af':'var(--dark)', cursor: page>=totalPages?'not-allowed':'pointer', fontSize:14, borderRadius:4, fontWeight:600 }}>
                ›
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ─── Product Form ───────────────────────────── */
function ProductForm({ initial, onSave, onCancel }) {
  const isMobile = useIsMobile();
  const [form, setForm] = useState({
    brand:'', name:'', category:'', price:'', was:'', stock:'1',
    condition:'New', dimensions:'', serial_ref:'', description:'', img:'', badge:'', sku:'',
    images:[], colors:[],
    show_home: 1,
    ...initial,
    images: Array.isArray(initial?.images) ? initial.images : [],
    colors: Array.isArray(initial?.colors) ? initial.colors : typeof initial?.colors==='string'&&initial.colors ? (()=>{try{return JSON.parse(initial.colors);}catch{return [];}})() : [],
    sku: initial?.sku || '',
  });
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [colorInput, setColorInput] = useState('#000000');
  const fileRef = useRef(); const extraImgRef = useRef();

  useEffect(() => {
    getBrands().then(d=>setBrands(Array.isArray(d)?d:[])).catch(()=>{});
    getCategories().then(d=>setCategories(Array.isArray(d)?d:[])).catch(()=>{});
  }, []);

  function onChange(e) { setForm(f=>({...f,[e.target.name]:e.target.value})); }

  async function handleUpload(e) {
    const file=e.target.files?.[0]; if(!file) return;
    setUploading(true);
    try { const res=await uploadImage(file); setForm(f=>({...f,img:res.url||res.path||res.file})); }
    catch(err) { alert('Upload failed: '+err.message); }
    finally { setUploading(false); }
  }

  async function handleExtraImages(e) {
    const files=Array.from(e.target.files||[]); const remaining=5-(form.images?.length||0); const toUpload=files.slice(0,remaining);
    setUploading(true);
    try { const urls=await Promise.all(toUpload.map(f=>uploadImage(f).then(r=>r.url||r.path||r.file))); setForm(f=>({...f,images:[...(f.images||[]),...urls]})); }
    catch(err) { alert('Upload failed: '+err.message); }
    finally { setUploading(false); e.target.value=''; }
  }

  async function handleSubmit(e) {
    e.preventDefault(); setSaving(true);
    try {
      const sku=form.sku?.trim()||`${(form.brand||'PRD').toUpperCase().replace(/\s+/g,'').slice(0,3)}-${(form.category||'GEN').toUpperCase().replace(/\s+/g,'').slice(0,3)}-${Math.random().toString(36).substring(2,6).toUpperCase()}`;
      await onSave({ ...form, sku, price: Number(form.price) || 0,  was:form.was?Number(form.was):null, stock:Number(form.stock), colors:JSON.stringify(form.colors||[]), images:JSON.stringify(form.images||[]) });
    } catch(err) { alert('Error: '+err.message); setSaving(false); }
  }

  const fields = [
    { name:'name', label:'Product Name *', type:'text' },
    { name:'price', label:'Price (₹) *', type:'number' },
    { name:'was', label:'Was Price (₹)', type:'number' },
    { name:'stock', label:'Stock Qty *', type:'number' },
    { name:'condition', label:'Condition', type:'select', options:['New','Like New','Excellent','Very Good','Good'] },
    { name:'badge', label:'Badge', type:'text', placeholder:'Sale, New, etc.' },
    { name:'dimensions', label:'Dimensions', type:'text' },
    { name:'serial_ref', label:'Reference / Serial', type:'text' },
  ];

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:24 }}>
        <button onClick={onCancel} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--grey-dark)', fontSize:14 }}>← Back</button>
        <h2 style={{ fontSize:16, fontWeight:600, color:'var(--dark)' }}>{initial?'Edit Product':'Add New Product'}</h2>
        {initial?.sku&&<code style={{ fontSize:11, background:'#f3f4f6', padding:'3px 10px', color:'var(--grey-dark)' }}>{initial.sku}</code>}
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:24 }}>
          {/* Left */}
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.1em' }}>Main Image</h3>
              <div style={{ border:'2px dashed var(--grey)', padding:24, textAlign:'center', marginBottom:12, cursor:'pointer', transition:'border-color 0.2s', minHeight:160, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={()=>fileRef.current?.click()} onMouseEnter={e=>e.currentTarget.style.borderColor='var(--dark)'} onMouseLeave={e=>e.currentTarget.style.borderColor='var(--grey)'}>
                {form.img ? <img src={imgSrc(form.img)||form.img} alt="" style={{ maxHeight:200, maxWidth:'100%', objectFit:'contain', mixBlendMode:'multiply' }}/> : <div><div style={{ fontSize:32, marginBottom:8 }}>📷</div><p style={{ fontSize:12, color:'var(--grey-mid)', margin:0 }}>{uploading?'Uploading…':'Click to upload main image'}</p></div>}
              </div>
              <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleUpload}/>
              <input name="img" value={form.img} onChange={onChange} placeholder="Or paste image URL" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
            </div>
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:12, textTransform:'uppercase', letterSpacing:'0.1em' }}>Additional Images ({form.images.length}/5)</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:8, marginBottom:10 }}>
                {form.images.map((img,i)=>(
                  <div key={i} style={{ position:'relative', aspectRatio:'1', background:'var(--grey-light)', overflow:'hidden' }}>
                    <img src={imgSrc(img)||img} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', mixBlendMode:'multiply' }}/>
                    <button type="button" onClick={()=>setForm(f=>({...f,images:f.images.filter((_,idx)=>idx!==i)}))} style={{ position:'absolute', top:2, right:2, width:18, height:18, borderRadius:'50%', background:'rgba(239,68,68,0.9)', border:'none', cursor:'pointer', color:'#fff', fontSize:10, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
                  </div>
                ))}
                {form.images.length<5&&<div onClick={()=>extraImgRef.current?.click()} style={{ aspectRatio:'1', border:'2px dashed var(--grey)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:22, color:'var(--grey-mid)' }} onMouseEnter={e=>e.currentTarget.style.borderColor='var(--dark)'} onMouseLeave={e=>e.currentTarget.style.borderColor='var(--grey)'}>+</div>}
              </div>
              <input ref={extraImgRef} type="file" accept="image/*" multiple hidden onChange={handleExtraImages}/>
            </div>
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:12, textTransform:'uppercase', letterSpacing:'0.1em' }}>Description</h3>
              <textarea name="description" value={form.description} onChange={onChange} rows={6} style={{ ...inp, resize:'vertical' }} placeholder="Product description…" onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
            </div>
          </div>
          {/* Right */}
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:12, textTransform:'uppercase', letterSpacing:'0.1em' }}>Product Code (SKU)</h3>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <input name="sku" value={form.sku} onChange={onChange} placeholder="Auto-generated if left empty" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
                <button type="button" onClick={()=>{const sku=`${(form.brand||'PRD').toUpperCase().replace(/\s+/g,'').slice(0,3)}-${(form.category||'GEN').toUpperCase().replace(/\s+/g,'').slice(0,3)}-${Math.random().toString(36).substring(2,6).toUpperCase()}`;setForm(f=>({...f,sku}));}} style={{ padding:'10px 14px', background:'var(--dark)', color:'#fff', border:'none', cursor:'pointer', fontSize:11, fontWeight:700, whiteSpace:'nowrap', flexShrink:0 }}>Generate</button>
              </div>
            </div>
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.1em' }}>Product Details</h3>
              <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:12 }}>
                {/* Brand */}
                <div style={{ gridColumn:'span 2' }}>
                  <label style={label}>Brand *</label>
                  {brands.length>0 ? (
                    <div style={{ position:'relative' }}>
                      <select name="brand" value={form.brand} onChange={onChange} style={{ ...inp, cursor:'pointer', appearance:'none', paddingRight:36 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}>
                        <option value="">— Select Brand —</option>
                        {brands.map(b=><option key={b.id} value={b.name}>{b.name}</option>)}
                      </select>
                      <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:'var(--grey-mid)' }}>▾</div>
                    </div>
                  ) : (
                    <input name="brand" value={form.brand} onChange={onChange} placeholder="Enter brand name" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
                  )}
                </div>
                {/* Category */}
                <div style={{ gridColumn:'span 2' }}>
                  <label style={label}>Category</label>
                  {categories.length>0 ? (
                    <div style={{ position:'relative' }}>
                      <select name="category" value={form.category} onChange={onChange} style={{ ...inp, cursor:'pointer', appearance:'none', paddingRight:36 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}>
                        <option value="">— Select Category —</option>
                        {categories.map(c=><option key={c.id} value={c.name}>{c.name}</option>)}
                      </select>
                      <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:'var(--grey-mid)' }}>▾</div>
                    </div>
                  ) : (
                    <input name="category" value={form.category} onChange={onChange} placeholder="e.g. Handbags, Wallets" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
                  )}
                </div>
                {fields.map(({name,label:lbl,type,options,placeholder})=>(
                  <div key={name} style={{ gridColumn: name==='name'?'span 2':'span 1' }}>
                    <label style={label}>{lbl}</label>
                    {type==='select' ? (
                      <select name={name} value={form[name]} onChange={onChange} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}>
                        {options.map(o=><option key={o} value={o}>{o}</option>)}
                      </select>
                    ) : (
                      <input name={name} type={type} value={form[name]} onChange={onChange} placeholder={placeholder||''} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {/* Colors */}
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.1em' }}>Available Colors <span style={{ fontWeight:400, color:'var(--grey-mid)', textTransform:'none', fontSize:11 }}>(optional)</span></h3>
              {form.colors.length>0&&<div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:16 }}>{form.colors.map((c,i)=><div key={i} style={{ position:'relative', display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}><div style={{ width:36, height:36, borderRadius:'50%', background:c, border:'2px solid rgba(0,0,0,0.1)' }}/><span style={{ fontSize:9, color:'var(--grey-mid)' }}>{c}</span><button type="button" onClick={()=>setForm(f=>({...f,colors:f.colors.filter((_,idx)=>idx!==i)}))} style={{ position:'absolute', top:-4, right:-4, width:16, height:16, borderRadius:'50%', background:'#ef4444', border:'none', cursor:'pointer', color:'#fff', fontSize:9, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button></div>)}</div>}
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <input type="color" value={colorInput} onChange={e=>setColorInput(e.target.value)} style={{ width:44, height:44, border:'1px solid var(--grey)', cursor:'pointer', padding:2, background:'#fff', borderRadius:4, flexShrink:0 }}/>
                <input type="text" value={colorInput} onChange={e=>setColorInput(e.target.value)} placeholder="#000000" style={{ ...inp, maxWidth:110 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
                <button type="button" onClick={()=>{ const hex=colorInput.trim(); if(!hex||form.colors.includes(hex)) return; setForm(f=>({...f,colors:[...f.colors,hex]})); }} style={{ padding:'10px 16px', background:'var(--dark)', color:'#fff', border:'none', cursor:'pointer', fontSize:11, fontWeight:700, whiteSpace:'nowrap', flexShrink:0 }}>+ Add</button>
              </div>
            </div>
            {/* In the Right column, add before the save buttons */}
            <div style={card}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'var(--dark)', marginBottom:12, textTransform:'uppercase', letterSpacing:'0.1em' }}>
                Shop Visibility
              </h3>
              <button
                type="button"
                onClick={() => setForm(f => ({ ...f, show_home: f.show_home ? 0 : 1 }))}
                style={{
                  width: '100%', padding: 10,
                  border: `2px solid ${form.show_home ? '#16a34a' : 'var(--grey)'}`,
                  background: form.show_home ? '#dcfce7' : '#fff',
                  color: form.show_home ? '#16a34a' : 'var(--grey-dark)',
                  fontSize: 12, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
                }}
              >
                {form.show_home ? '✓ Visible in Shop' : 'Hidden from Shop'}
              </button>
              <p style={{ fontSize:11, color:'var(--grey-mid)', margin:'8px 0 0' }}>
                Hidden products are kept in admin but won't appear on the shop page.
              </p>
            </div>
            <div style={{ display:'flex', gap:12 }}>
              <button type="button" onClick={onCancel} style={{ ...btn('ghost'), flex:1 }}>Cancel</button>
              <button type="submit" disabled={saving||uploading} style={{ ...btn('dark'), flex:2, opacity:(saving||uploading)?0.7:1 }}>{saving?'Saving…':uploading?'Uploading…':initial?'Update Product':'Create Product'}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

/* ─── Banners ────────────────────────────────── */
function SectionBanners() {
  const [banners,setBanners]=useState([]);
  const [editing,setEditing]=useState(null);
  const [showForm,setShowForm]=useState(false);
  const fileRef=useRef();
  const [uploading,setUploading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [formData,setFormData]=useState({ title:'',subtitle:'',cta:'Shop the Collection',cta_filter:'all',img:'',sort_order:0 });
  const isMobile = useIsMobile();

  useEffect(()=>{ getBanners().then(b=>setBanners(Array.isArray(b)?b:[])).catch(()=>{}); },[]);

  function openNew(){ setEditing(null); setFormData({title:'',subtitle:'',cta:'Shop the Collection',cta_filter:'all',img:'',sort_order:0}); setShowForm(true); }
  function openEdit(b){ setEditing(b); setFormData({title:b.title||'',subtitle:b.subtitle||'',cta:b.cta||'Shop the Collection',cta_filter:b.cta_filter||'all',img:b.img||'',sort_order:b.sort_order||0}); setShowForm(true); }

  async function handleUpload(e){ const file=e.target.files?.[0]; if(!file) return; setUploading(true); try{ const res=await uploadImage(file); setFormData(f=>({...f,img:res.url||res.path||res.file})); }catch(err){alert('Upload failed: '+err.message);}finally{setUploading(false);} }

  async function handleSave(e){
    e.preventDefault(); if(!formData.title){alert('Title is required');return;} if(!formData.img){alert('Image is required');return;} setSaving(true);
    try{ if(editing){await updateBanner(editing.id,formData);setBanners(prev=>prev.map(b=>b.id===editing.id?{...b,...formData}:b));}else{const created=await createBanner(formData);setBanners(prev=>[...prev,created]);} setShowForm(false); setEditing(null); getBanners().then(b=>setBanners(Array.isArray(b)?b:[])).catch(()=>{}); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);}
  }

  async function handleDelete(id){ if(!window.confirm('Delete banner?')) return; await deleteBanner(id); setBanners(prev=>prev.filter(b=>b.id!==id)); }
  async function handleToggle(id){ await toggleBanner(id); setBanners(prev=>prev.map(b=>b.id===id?{...b,active:b.active?0:1}:b)); }

  if(showForm) return (
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}>
        <button onClick={()=>{setShowForm(false);setEditing(null);}} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button>
        <h2 style={{ fontSize:16,fontWeight:600 }}>{editing?'Edit Banner':'New Banner'}</h2>
      </div>
      <form onSubmit={handleSave} style={{ maxWidth:640 }}>
        <div style={{ ...card,display:'flex',flexDirection:'column',gap:18 }}>
          <div>
            <label style={label}>Banner Image *</label>
            <div style={{ border:'2px dashed var(--grey)',padding:24,textAlign:'center',cursor:'pointer',marginBottom:10,transition:'border-color 0.2s',minHeight:140,display:'flex',alignItems:'center',justifyContent:'center' }} onClick={()=>fileRef.current?.click()} onMouseEnter={e=>e.currentTarget.style.borderColor='var(--dark)'} onMouseLeave={e=>e.currentTarget.style.borderColor='var(--grey)'}>
              {/* {formData.img?<img src={formData.img.startsWith('http')?formData.img:`${BASE_URL}${formData.img}`} alt="" style={{ maxHeight:160,maxWidth:'100%',objectFit:'cover' }}/> */}
              {formData.img?<img src={imgSrc(formData.img)} alt="" style={{ maxHeight:160,maxWidth:'100%',objectFit:'cover' }}/>

              :<div><div style={{ fontSize:32,marginBottom:8 }}>🖼</div><p style={{ fontSize:12,color:'var(--grey-mid)' }}>{uploading?'Uploading…':'Click to upload banner image'}</p></div>}
            </div>
            <input ref={fileRef} type="file" accept="image/*" style={{ display:'none' }} onChange={handleUpload}/>
            <input value={formData.img} onChange={e=>setFormData(f=>({...f,img:e.target.value}))} placeholder="Or paste image URL" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
          </div>
          {[{key:'title',lbl:'Title *',ph:'e.g. Authenticated Luxury'},{key:'subtitle',lbl:'Subtitle',ph:'e.g. Curated for the discerning few'},{key:'cta',lbl:'Button Text',ph:'e.g. Shop the Collection'},{key:'cta_filter',lbl:'Button Filter',ph:'all, Handbags, etc.'}].map(({key,lbl,ph})=>(
            <div key={key}><label style={label}>{lbl}</label><input value={formData[key]} onChange={e=>setFormData(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          ))}
          <div><label style={label}>Sort Order</label><input type="number" value={formData.sort_order} onChange={e=>setFormData(f=>({...f,sort_order:Number(e.target.value)}))} style={{ ...inp,maxWidth:120 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div style={{ display:'flex',gap:12,paddingTop:8 }}>
            <button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ ...btn('ghost'),flex:1 }}>Cancel</button>
            <button type="submit" disabled={saving||uploading} style={{ ...btn('dark'),flex:2,opacity:(saving||uploading)?0.7:1 }}>{saving?'Saving…':uploading?'Uploading…':editing?'Update Banner':'Create Banner'}</button>
          </div>
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <p style={{ fontSize:13,color:'var(--grey-dark)' }}><strong>{banners.length}</strong> banner{banners.length!==1?'s':''}</p>
        <button onClick={openNew} style={btn('gold')}>+ Add Banner</button>
      </div>
      <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(340px,1fr))',gap:16 }}>
        {banners.map(b=>(
          <div key={b.id} style={card}>
            <div style={{ aspectRatio:'16/6',background:'var(--dark)',marginBottom:14,overflow:'hidden',position:'relative' }}>
              {/* {b.img&&<img src={b.img.startsWith('http')?b.img:`${BASE_URL}${b.img}`} alt="" style={{ width:'100%',height:'100%',objectFit:'cover',opacity:0.55 }}/>} */}
              {b.img&&<img src={imgSrc(b.img)} alt="" style={{ width:'100%',height:'100%',objectFit:'cover',opacity:0.55 }}/>}

              <div style={{ position:'absolute',inset:0,background:'linear-gradient(to right,rgba(26,26,26,0.7),rgba(26,26,26,0.2))' }}/>
              <div style={{ position:'absolute',inset:0,display:'flex',flexDirection:'column',justifyContent:'center',padding:'0 20px' }}>
                <div style={{ fontFamily:'var(--font-display)',fontSize:16,color:'#fff',fontWeight:300,marginBottom:4 }}>{b.title||'(No Title)'}</div>
                {b.subtitle&&<div style={{ fontSize:11,color:'rgba(255,255,255,0.55)' }}>{b.subtitle}</div>}
              </div>
              <div style={{ position:'absolute',top:8,right:8,background:b.active?'#16a34a':'#6b7280',color:'#fff',fontSize:9,letterSpacing:'0.1em',padding:'3px 8px',fontWeight:700 }}>{b.active?'ACTIVE':'HIDDEN'}</div>
            </div>
            <div style={{ marginBottom:12 }}>
              <div style={{ fontSize:12,fontWeight:600,color:'var(--dark)',marginBottom:2 }}>{b.title||'—'}</div>
              <div style={{ fontSize:11,color:'var(--grey-mid)' }}>{b.subtitle||'—'}</div>
              <div style={{ fontSize:10,color:'var(--grey-mid)',marginTop:4 }}>CTA: <strong>{b.cta||'—'}</strong> · Filter: <strong>{b.cta_filter||'all'}</strong></div>
            </div>
            <div style={{ display:'flex',gap:8,flexWrap:'wrap' }}>
              <button onClick={()=>handleToggle(b.id)} style={{ padding:'7px 12px',fontSize:11,fontWeight:600,cursor:'pointer',border:'none',background:b.active?'#fef3c7':'#dcfce7',color:b.active?'#92400e':'#166534' }}>{b.active?'Deactivate':'Activate'}</button>
              <button onClick={()=>openEdit(b)} style={{ padding:'7px 12px',fontSize:11,fontWeight:600,cursor:'pointer',background:'var(--dark)',color:'#fff',border:'none' }}>Edit</button>
              <button onClick={()=>handleDelete(b.id)} style={{ padding:'7px 12px',fontSize:11,fontWeight:600,cursor:'pointer',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca' }}>Delete</button>
            </div>
          </div>
        ))}
        {banners.length===0&&<p style={{ fontSize:12,color:'var(--grey-mid)',padding:32 }}>No banners yet.</p>}
      </div>
    </div>
  );
}

/* ─── Categories ─────────────────────────────── */
function SectionCategories() {
  const [cats,setCats]=useState([]); const [editing,setEditing]=useState(null); const [showForm,setShowForm]=useState(false);
  const [saving,setSaving]=useState(false); const [uploading,setUploading]=useState(false); const fileRef=useRef();
  const [form,setForm]=useState({name:'',img:'',sort_order:0,show_home:false});
  const isMobile = useIsMobile();

  useEffect(()=>{ getCategories().then(d=>setCats(Array.isArray(d)?d:[])).catch(()=>{}); },[]);

  function openNew(){ setEditing(null); setForm({name:'',img:'',sort_order:0,show_home:false}); setShowForm(true); }
  function openEdit(c){ setEditing(c); setForm({name:c.name||'',img:c.img||'',sort_order:c.sort_order||0,show_home:!!+c.show_home}); setShowForm(true); }

  async function handleUpload(e){ const file=e.target.files?.[0]; if(!file) return; setUploading(true); try{ const res=await uploadImage(file); setForm(f=>({...f,img:res.url||res.path||res.file})); }catch(err){alert('Upload failed: '+err.message);}finally{setUploading(false);} }
  async function handleSave(e){
    e.preventDefault(); if(!form.name){alert('Name is required');return;} setSaving(true);
    try{ if(editing){await updateCategory(editing.id,form);setCats(prev=>prev.map(c=>c.id===editing.id?{...c,...form}:c));}else{const created=await createCategory(form);setCats(prev=>[...prev,created]);} setShowForm(false); setEditing(null); getCategories().then(d=>setCats(Array.isArray(d)?d:[])).catch(()=>{}); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);}
  }
  async function handleToggleHome(id){ try{ const res=await toggleCategoryHome(id); setCats(prev=>prev.map(c=>c.id===id?{...c,show_home:res.show_home}:c)); }catch(err){alert(err.message);} }
  async function handleDelete(id){ if(!window.confirm('Delete category?')) return; await deleteCategory(id); setCats(prev=>prev.filter(c=>c.id!==id)); }

  const homeCount=cats.filter(c=>+c.show_home===1).length;

  if(showForm) return (
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}>
        <button onClick={()=>{setShowForm(false);setEditing(null);}} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button>
        <h2 style={{ fontSize:16,fontWeight:600 }}>{editing?'Edit Category':'New Category'}</h2>
      </div>
      <form onSubmit={handleSave} style={{ maxWidth:560 }}>
        <div style={{ ...card,display:'flex',flexDirection:'column',gap:18 }}>
          <div>
            <label style={label}>Category Image</label>
            <div style={{ border:'2px dashed var(--grey)',padding:24,textAlign:'center',cursor:'pointer',marginBottom:10,minHeight:160,display:'flex',alignItems:'center',justifyContent:'center',transition:'border-color 0.2s' }} onClick={()=>fileRef.current?.click()} onMouseEnter={e=>e.currentTarget.style.borderColor='var(--dark)'} onMouseLeave={e=>e.currentTarget.style.borderColor='var(--grey)'}>
              {form.img?<img src={imgSrc(form.img)} alt="" style={{ maxHeight:180,maxWidth:'100%',objectFit:'cover' }}/>:<div><div style={{ fontSize:32,marginBottom:8 }}>🗂</div><p style={{ fontSize:12,color:'var(--grey-mid)' }}>{uploading?'Uploading…':'Click to upload image'}</p></div>}
            </div>
            <input ref={fileRef} type="file" accept="image/*" style={{ display:'none' }} onChange={handleUpload}/>
            <input value={form.img} onChange={e=>setForm(f=>({...f,img:e.target.value}))} placeholder="Or paste image URL" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
          </div>
          <div><label style={label}>Category Name *</label><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Handbags, Wallets" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div><label style={label}>Sort Order</label><input type="number" value={form.sort_order} onChange={e=>setForm(f=>({...f,sort_order:Number(e.target.value)}))} style={{ ...inp,maxWidth:120 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div><label style={label}>Show on Homepage</label><button type="button" onClick={()=>setForm(f=>({...f,show_home:!f.show_home}))} style={{ width:'100%',padding:10,border:`2px solid ${form.show_home?'var(--green)':'var(--grey)'}`,background:form.show_home?'#dcfce7':'#fff',color:form.show_home?'var(--green)':'var(--grey-dark)',fontSize:12,fontWeight:600,cursor:'pointer',transition:'all 0.2s' }}>{form.show_home?'✓ Shown on Homepage':'Hidden from Homepage'}</button></div>
          <div style={{ display:'flex',gap:12,paddingTop:8 }}>
            <button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ ...btn('ghost'),flex:1 }}>Cancel</button>
            <button type="submit" disabled={saving||uploading} style={{ ...btn('dark'),flex:2,opacity:(saving||uploading)?0.7:1 }}>{saving?'Saving…':uploading?'Uploading…':editing?'Update Category':'Create Category'}</button>
          </div>
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
        <div>
          {/* <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{cats.length}</strong> categories · <span style={{ color:homeCount>=3?'var(--green)':'var(--gold)' }}><strong>{homeCount}/3</strong> on homepage</span></p> */}
          <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{cats.length}</strong> categories · <span style={{ color:homeCount>=4?'var(--green)':'var(--gold)' }}><strong>{homeCount}/4</strong> on homepage</span></p>
        </div>
        <button onClick={openNew} style={btn('gold')}>+ Add Category</button>
      </div>
      <div style={{ display:'grid',gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fill,minmax(280px,1fr))',gap: isMobile ? 10 : 16 }}>
        {cats.map(c=>(
          <div key={c.id} style={card}>
            <div style={{ height: isMobile ? 120 : 160,background:'#e8e4df',marginBottom:14,overflow:'hidden',position:'relative' }}>
              {c.img&&<img src={imgSrc(c.img)} alt={c.name} style={{ width:'100%',height:'100%',objectFit:'cover' }}/>}
              {!c.img&&<div style={{ width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center' }}><span style={{ fontSize:40,opacity:0.25 }}>🗂</span></div>}
              <div style={{ position:'absolute',bottom:0,left:0,right:0,background:'linear-gradient(to top,rgba(0,0,0,0.6),transparent)',padding:'24px 14px 12px' }}>
                <div style={{ fontFamily:'var(--font-display)',fontSize: isMobile ? 14 : 18,color:'#fff',fontWeight:300 }}>{c.name}</div>
              </div>
              <div style={{ position:'absolute',top:8,right:8,background:+c.show_home?'#16a34a':'#6b7280',color:'#fff',fontSize:9,letterSpacing:'0.1em',padding:'3px 8px',fontWeight:700 }}>{+c.show_home?'ON HOME':'HIDDEN'}</div>
            </div>
            <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
              {/* <button onClick={()=>handleToggleHome(c.id)} disabled={!+c.show_home&&homeCount>=3} style={{ padding:'6px 10px',fontSize:11,fontWeight:600,cursor:(!+c.show_home&&homeCount>=3)?'not-allowed':'pointer',border:'none',opacity:(!+c.show_home&&homeCount>=3)?0.4:1,background:+c.show_home?'#fef3c7':'#dcfce7',color:+c.show_home?'#92400e':'#166534' }}>{+c.show_home?'Hide':'Show'}</button> */}
              <button onClick={()=>handleToggleHome(c.id)} disabled={!+c.show_home&&homeCount>=4} style={{ padding:'6px 10px',fontSize:11,fontWeight:600,cursor:(!+c.show_home&&homeCount>=4)?'not-allowed':'pointer',border:'none',opacity:(!+c.show_home&&homeCount>=4)?0.4:1,background:+c.show_home?'#fef3c7':'#dcfce7',color:+c.show_home?'#92400e':'#166634' }}>{+c.show_home?'Hide':'Show'}</button>

              <button onClick={()=>openEdit(c)} style={{ padding:'6px 10px',fontSize:11,fontWeight:600,cursor:'pointer',background:'var(--dark)',color:'#fff',border:'none' }}>Edit</button>
              <button onClick={()=>handleDelete(c.id)} style={{ padding:'6px 10px',fontSize:11,fontWeight:600,cursor:'pointer',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca' }}>Del</button>
            </div>
          </div>
        ))}
        {cats.length===0&&<p style={{ fontSize:12,color:'var(--grey-mid)',padding:32 }}>No categories yet.</p>}
      </div>
    </div>
  );
}

/* ─── Featured Products ──────────────────────── */
function SectionFeatured() {
  const [featured,setFeatured]=useState([]); const [products,setProducts]=useState([]); const [search,setSearch]=useState(''); const [loading,setLoading]=useState(true);
  const isMobile = useIsMobile();

  useEffect(()=>{ Promise.all([getAdminFeatured().catch(()=>[]),getProducts().catch(()=>[])]).then(([feat,prods])=>{ setFeatured(Array.isArray(feat)?feat:[]); setProducts(Array.isArray(prods)?prods:[]); }).finally(()=>setLoading(false)); },[]);

  const featuredIds=featured.map(f=>f.product_id||f.id);
  const filtered=products.filter(p=>!featuredIds.includes(p.id)&&(p.name.toLowerCase().includes(search.toLowerCase())||p.brand.toLowerCase().includes(search.toLowerCase())));

  async function handleAdd(productId){ if(featured.length>=4){alert('Maximum 4 featured products');return;} try{ await addFeaturedProduct(productId); const updated=await getAdminFeatured(); setFeatured(Array.isArray(updated)?updated:[]); }catch(err){alert(err.message);} }
  async function handleRemove(productId){ await removeFeaturedProduct(productId); setFeatured(prev=>prev.filter(f=>(f.product_id||f.id)!==productId)); }

  if(loading) return <p style={{ fontSize:12,color:'var(--grey-mid)' }}>Loading…</p>;

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:24 }}>
      <div style={{ ...card,background:'#fffbeb',border:'1px solid #fde68a' }}>
        <p style={{ fontSize:12,color:'#92400e',margin:0 }}><strong>⭐ Featured Products</strong> — Select exactly 4 products to show in "The House Selection" on the homepage.</p>
      </div>
      <div style={card}>
        <h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:16,textTransform:'uppercase',letterSpacing:'0.1em' }}>Currently Featured ({featured.length}/4)</h3>
        {featured.length===0 ? <p style={{ fontSize:12,color:'var(--grey-mid)' }}>No featured products yet.</p> : (
          <div style={{ display:'grid',gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fill,minmax(200px,1fr))',gap:12 }}>
            {featured.map((f,i)=>(
              <div key={f.product_id||f.id} style={{ border:'1px solid var(--grey)',padding:12,position:'relative' }}>
                <div style={{ position:'absolute',top:8,left:8,background:'var(--gold)',color:'#fff',fontSize:9,fontWeight:700,padding:'2px 6px' }}>#{i+1}</div>
                <div style={{ height:120,background:'var(--grey-light)',marginBottom:10,overflow:'hidden' }}>{f.img&&<img src={imgSrc(f.img)} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }}/>}</div>
                <div style={{ fontSize:9,color:'var(--grey-mid)',textTransform:'uppercase' }}>{f.brand}</div>
                <div style={{ fontSize:12,fontWeight:600,color:'var(--dark)',marginBottom:4 }}>{f.name}</div>
                <button onClick={()=>handleRemove(f.product_id||f.id)} style={{ width:'100%',padding:'6px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Remove</button>
              </div>
            ))}
          </div>
        )}
      </div>
      {featured.length<4&&(
        <div style={card}>
          <h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:16,textTransform:'uppercase',letterSpacing:'0.1em' }}>Add Products ({4-featured.length} slots remaining)</h3>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search products…" style={{ ...inp,maxWidth:320,marginBottom:16 }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
          <div style={{ display:'grid',gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fill,minmax(200px,1fr))',gap:12,maxHeight:400,overflowY:'auto' }}>
            {filtered.map(p=>(
              <div key={p.id} style={{ border:'1px solid var(--grey)',padding:12 }}>
                <div style={{ height:100,background:'var(--grey-light)',marginBottom:10,overflow:'hidden' }}>{p.img&&<img src={imgSrc(p.img)} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }}/>}</div>
                <div style={{ fontSize:9,color:'var(--grey-mid)',textTransform:'uppercase' }}>{p.brand}</div>
                <div style={{ fontSize:12,fontWeight:600,color:'var(--dark)',marginBottom:4 }}>{p.name}</div>
                <button onClick={()=>handleAdd(p.id)} style={{ width:'100%',padding:'6px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>+ Add</button>
              </div>
            ))}
            {filtered.length===0&&<p style={{ fontSize:12,color:'var(--grey-mid)',gridColumn:'1/-1' }}>No products found.</p>}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Orders ─────────────────────────────────── */
function SectionOrders() {
  const [orders, setOrders]           = useState([]);
  const [page, setPage]               = useState(1);
  const [totalPages, setTotalPages]   = useState(1);
  const [totalOrders, setTotalOrders] = useState(0);
  const [showForm, setShowForm]       = useState(false);
  const [saving, setSaving]           = useState(false);
  const [activeTab, setActiveTab]     = useState('All');
  const [viewOrder, setViewOrder]     = useState(null);
  const [editing, setEditing]         = useState(null);
  const [statusMsg, setStatusMsg]     = useState('');
  const [orderBrands, setOrderBrands]         = useState([]);
  const [orderCategories, setOrderCategories] = useState([]);
  const [promoCode, setPromoCode]       = useState('');
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [promoError, setPromoError]     = useState('');
  // Add this state at the top of SectionOrders
const [updatingRef, setUpdatingRef] = useState(null);
  const [form, setForm] = useState({
    customer_name: '', customer_phone: '', customer_email: '',
    customer_address: '', status: 'Processing', notes: '', total: ''
  });
  const [orderItems, setOrderItems] = useState([
    { product_id: '', brand: '', name: '', category: '', qty: 1, price: '' }
  ]);

  const [LIMIT, setLimitState] = useState(10);
  const STATUS_OPTIONS = ['Processing', 'Confirmed', 'Shipped', 'Delivered', 'Cancelled'];
  const TABS           = ['All', 'Processing', 'Confirmed', 'Shipped', 'Delivered', 'Cancelled'];
  const STATUS_COLOR   = {
    processing: { bg: '#fef9c3', color: '#ca8a04' },
    confirmed:  { bg: '#d1fae5', color: '#065f46' },
    shipped:    { bg: '#dbeafe', color: '#2563eb' },
    delivered:  { bg: '#dcfce7', color: '#16a34a' },
    cancelled:  { bg: '#fee2e2', color: '#dc2626' },
    pending:    { bg: '#fef3c7', color: '#d97706' },
  };

  const isMobile = useIsMobile();

  // ── Load orders with pagination ──
  function loadOrders(p = 1, limit = LIMIT) {
    getOrders(p, limit).then(d => {
      setOrders(Array.isArray(d) ? d : d?.orders || []);
      setPage(d?.page || p);
      setTotalPages(d?.total_pages || 1);
      setTotalOrders(d?.total || 0);
    }).catch(() => {});
  }

  useEffect(() => {
    loadOrders(1, 10);
    getBrands().then(d => setOrderBrands(Array.isArray(d) ? d : [])).catch(() => {});
    getCategories().then(d => setOrderCategories(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  // ── Tab filter (client-side on current page) ──
  const filteredOrders = activeTab === 'All'
    ? orders
    : orders.filter(o => (o.status || '').toLowerCase() === activeTab.toLowerCase());

  // ── Reset form ──
  function resetForm() {
    setForm({ customer_name: '', customer_phone: '', customer_email: '', customer_address: '', status: 'Processing', notes: '', total: '' });
    setOrderItems([{ product_id: '', brand: '', name: '', category: '', qty: 1, price: '' }]);
    setEditing(null);
    setPromoCode('');
    setPromoDiscount(0);
    setPromoError('');
  }

  // ── Open edit ──
  function openEdit(o) {
    let items = o.items;
    if (typeof items === 'string') { try { items = JSON.parse(items); } catch { items = null; } }
    const parsedItems = Array.isArray(items) && items.length > 0
      ? items.map(i => ({ product_id: i.sku || i.product_id || i.id || '', brand: i.brand || '', name: i.name || '', category: i.category || '', qty: i.qty || 1, price: i.price || '' }))
      : [{ product_id: '', brand: '', name: '', category: '', qty: 1, price: '' }];
    setOrderItems(parsedItems);
    setEditing(o);
    setPromoCode('');
    setPromoDiscount(0);
    setPromoError('');
    setForm({
      customer_name:    o.customer_name    || '',
      customer_phone:   o.customer_phone   || '',
      customer_email:   o.customer_email   || '',
      customer_address: o.customer_address || '',
      status:           o.status           || 'Processing',
      notes:            o.notes            || '',
      total:            '',   // ← always blank so override is intentional
    });
    setShowForm(true);
  }

  // ── Update status ──
  // async function handleStatus(ref, status) {
  //   try {
  //     await updateOrderStatus(ref, status);
  //     setOrders(prev => prev.map(o => (o.ref === ref || o.order_ref === ref) ? { ...o, status } : o));
  //     if (viewOrder && (viewOrder.ref === ref || viewOrder.order_ref === ref)) {
  //       setViewOrder(prev => ({ ...prev, status }));
  //     }
  //     setStatusMsg(`✓ Order ${ref} status updated to "${status}"`);
  //     setTimeout(() => setStatusMsg(''), 3500);
  //   } catch {
  //     setStatusMsg('✗ Failed to update status');
  //     setTimeout(() => setStatusMsg(''), 3000);
  //   }
  // }
  async function handleStatus(ref, status) {
  setUpdatingRef(ref); // 👈 start loading
  try {
    await updateOrderStatus(ref, status);
    setOrders(prev => prev.map(o => (o.ref === ref || o.order_ref === ref) ? { ...o, status } : o));
    if (viewOrder && (viewOrder.ref === ref || viewOrder.order_ref === ref)) {
      setViewOrder(prev => ({ ...prev, status }));
    }
    setStatusMsg(`✓ Order ${ref} status updated to "${status}"`);
    setTimeout(() => setStatusMsg(''), 3500);
  } catch {
    setStatusMsg('✗ Failed to update status');
    setTimeout(() => setStatusMsg(''), 3000);
  } finally {
    setUpdatingRef(null); // 👈 stop loading
  }
}

  // ── Delete order ──
  // async function handleDelete(ref, id) {
  //   if (!window.confirm('Delete this order?')) return;
  //   try {
  //     await fetch(`${BASE_URL}/index.php?route=orders&id=${ref || id}`, {
  //       method: 'DELETE',
  //       headers: { 'Authorization': `Bearer ${localStorage.getItem('aurora_admin_token') || ''}` }
  //     });
  //   } catch {}
  //   setOrders(prev => prev.filter(o => (o.ref || o.order_ref) !== (ref || id) && o.id !== id));
  //   setTotalOrders(prev => prev - 1);
  // }

  async function handleDelete(ref, id) {
  if (!window.confirm('Delete this order?')) return;
  try {
    await deleteOrder(ref || id);
    setOrders(prev => prev.filter(o => (o.ref || o.order_ref) !== (ref || id) && o.id !== id));
    setTotalOrders(prev => prev - 1);
  } catch (err) {
    alert('Failed to delete: ' + err.message);
  }
}

  // ── Apply promo ──
  async function handleApplyPromo() {
    if (!promoCode) return;
    try {
      // always compute from items
      const itemsSubtotal = orderItems.reduce(
        (s, i) => s + (Number(i.price) * Number(i.qty || 1)), 0
      );

      const res = await validatePromo({
        code: promoCode,
        items: orderItems.map(i => ({
          sku:      i.product_id || '',
          brand:    i.brand      || '',
          category: i.category   || '',
          qty:      Number(i.qty)   || 1,
          price:    Number(i.price) || 0,
          name:     i.name       || '',
        })),
        subtotal: itemsSubtotal,
      });

      const pct           = Number(res.discount_pct || 0);
      const discountRupees = Math.round(itemsSubtotal * (pct / 100));

      setPromoDiscount(discountRupees);
      setPromoError('');
      alert(`Promo Applied — ${pct}% off = ₹${discountRupees.toLocaleString('en-IN')} discount`);

    } catch (err) {
      setPromoDiscount(0);
      setPromoError(err.message || 'Invalid Promo Code');
    }
  }

  // ── Create / Update order ──
  async function handleCreate(e) {
    e.preventDefault();
    if (!form.customer_name || !form.customer_phone) { alert('Name and phone are required'); return; }
    if (orderItems.some(i => !i.name)) { alert('Each item must have a product name'); return; }

    // ── FIXED: subtotal always from items, never from override field ──
    const computedTotal = orderItems.reduce(
      (sum, i) => sum + (Number(i.price) * Number(i.qty || 1)), 0
    );
    const subtotal   = computedTotal;   // items sum — saved to DB as subtotal
    const baseTotal  = form.total !== '' ? Number(form.total) : computedTotal;  // override or computed
    const finalTotal = baseTotal - promoDiscount;   // what customer pays

    setSaving(true);
    try {
      const itemsPayload = orderItems.map(i => ({
        sku:      i.product_id || '',
        brand:    i.brand,
        name:     i.name,
        category: i.category,
        qty:      Number(i.qty)   || 1,
        price:    Number(i.price) || 0,
      }));

      if (editing) {
        // ── Edit existing order ──
        const ref = editing.ref || editing.order_ref;
        await updateOrder(ref, {
          customer_name:    form.customer_name,
          customer_phone:   form.customer_phone,
          customer_email:   form.customer_email,
          customer_address: form.customer_address,
          total:            finalTotal,
          status:           form.status,
          items:            JSON.stringify(itemsPayload),
        });
        setOrders(prev => prev.map(o =>
          (o.ref === ref || o.order_ref === ref)
            ? { ...o, ...form, total: finalTotal, items: itemsPayload }
            : o
        ));
      } else {
        // ── Create new order ──
        const ref = 'ORD-' + Math.random().toString(36).substring(2, 8).toUpperCase();
        await placeOrder({
          ref,
          customer: {
            name:    form.customer_name,
            phone:   form.customer_phone,
            email:   form.customer_email   || '',
            address: form.customer_address || '',
          },
          items:        itemsPayload,
          subtotal:     subtotal,       // ← always clean items sum
          discount:     promoDiscount,  // ← rupee discount
          discount_pct: promoDiscount > 0
            ? Math.round((promoDiscount / subtotal) * 100)
            : null,
          promo_code:   promoCode || null,
          total:        finalTotal,     // ← subtotal - discount
          status:       form.status,
          date:         new Date().toISOString(),
        });
        loadOrders(1);
      }

      setShowForm(false);
      resetForm();
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setSaving(false);
    }
  }

  // ════════════════════════════════════════════════════
  // ORDER FORM (Create / Edit)
  // ════════════════════════════════════════════════════
  if (showForm) return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
        <button onClick={() => { setShowForm(false); resetForm(); }}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--grey-dark)', fontSize: 14 }}>
          ← Back
        </button>
        <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--dark)' }}>
          {editing ? 'Edit Order' : 'Create New Order'}
        </h2>
        {editing && (
          <code style={{ fontSize: 11, color: 'var(--grey-mid)', background: '#f3f4f6', padding: '3px 8px' }}>
            {editing.ref || editing.order_ref}
          </code>
        )}
      </div>

      <form onSubmit={handleCreate} style={{ maxWidth: 700 }}>
        <div style={{ ...card, display: 'flex', flexDirection: 'column', gap: 18 }}>

          {/* ── Customer Details ── */}
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--grey-dark)', paddingBottom: 8, borderBottom: '1px solid var(--grey)' }}>
            Customer Details
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            <div style={{ gridColumn: isMobile ? 'span 1' : 'span 2' }}>
              <label style={label}>Full Name *</label>
              <input value={form.customer_name} onChange={e => setForm(p => ({ ...p, customer_name: e.target.value }))}
                style={inp} onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div>
              <label style={label}>Phone *</label>
              <input value={form.customer_phone} onChange={e => setForm(p => ({ ...p, customer_phone: e.target.value }))}
                style={inp} onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div>
              <label style={label}>Email</label>
              <input type="email" value={form.customer_email} onChange={e => setForm(p => ({ ...p, customer_email: e.target.value }))}
                style={inp} onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div style={{ gridColumn: isMobile ? 'span 1' : 'span 2' }}>
              <label style={label}>Delivery Address</label>
              <textarea value={form.customer_address} onChange={e => setForm(p => ({ ...p, customer_address: e.target.value }))}
                rows={2} style={{ ...inp, resize: 'vertical' }}
                onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
          </div>

          {/* ── Order Items ── */}
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--grey-dark)', paddingBottom: 8, borderBottom: '1px solid var(--grey)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Order Items</span>
            <button type="button"
              onClick={() => setOrderItems(prev => [...prev, { product_id: '', brand: '', name: '', category: '', qty: 1, price: '' }])}
              style={{ fontSize: 11, fontWeight: 700, background: 'var(--dark)', color: '#fff', border: 'none', padding: '5px 12px', cursor: 'pointer' }}>
              + Add Item
            </button>
          </div>

          {orderItems.map((item, idx) => (
            <div key={idx} style={{ border: '1px solid #e5e7eb', padding: 14, background: '#fafafa', display: 'flex', flexDirection: 'column', gap: 10, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 8, right: 8, fontSize: 10, fontWeight: 700, color: 'var(--grey-mid)', background: '#f3f4f6', padding: '2px 8px' }}>
                Item {idx + 1}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: 10 }}>

                {/* Brand */}
                <div>
                  <label style={label}>Brand</label>
                  {orderBrands.length > 0 ? (
                    <div style={{ position: 'relative' }}>
                      <select value={item.brand}
                        onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, brand: e.target.value } : it))}
                        style={{ ...inp, cursor: 'pointer', appearance: 'none', paddingRight: 36 }}
                        onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'}>
                        <option value="">— Select Brand —</option>
                        {orderBrands.map(b => <option key={b.id} value={b.name}>{b.name}</option>)}
                      </select>
                      <div style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--grey-mid)' }}>▾</div>
                    </div>
                  ) : (
                    <input value={item.brand}
                      onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, brand: e.target.value } : it))}
                      placeholder="e.g. Louis Vuitton" style={inp}
                      onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                  )}
                </div>

                {/* Product Name */}
                <div>
                  <label style={label}>Product Name *</label>
                  <input value={item.name}
                    onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, name: e.target.value } : it))}
                    placeholder="e.g. Neverfull MM" style={inp}
                    onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>

                {/* Category */}
                <div>
                  <label style={label}>Category</label>
                  {orderCategories.length > 0 ? (
                    <div style={{ position: 'relative' }}>
                      <select value={item.category}
                        onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, category: e.target.value } : it))}
                        style={{ ...inp, cursor: 'pointer', appearance: 'none', paddingRight: 36 }}
                        onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'}>
                        <option value="">— Select Category —</option>
                        {orderCategories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                      </select>
                      <div style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--grey-mid)' }}>▾</div>
                    </div>
                  ) : (
                    <input value={item.category}
                      onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, category: e.target.value } : it))}
                      placeholder="e.g. Handbags" style={inp}
                      onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                  )}
                </div>

                {/* SKU */}
                <div>
                  <label style={label}>SKU (optional)</label>
                  <input value={item.product_id}
                    onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, product_id: e.target.value } : it))}
                    placeholder="e.g. LV-BAG-001" style={inp}
                    onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>

                {/* Qty */}
                <div>
                  <label style={label}>Quantity</label>
                  <input type="number" min="1" value={item.qty}
                    onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, qty: e.target.value } : it))}
                    style={inp}
                    onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>

                {/* Price */}
                <div>
                  <label style={label}>Price (₹)</label>
                  <input type="number" value={item.price}
                    onChange={e => setOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, price: e.target.value } : it))}
                    placeholder="0" style={inp}
                    onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>
              </div>

              {orderItems.length > 1 && (
                <button type="button"
                  onClick={() => setOrderItems(prev => prev.filter((_, i) => i !== idx))}
                  style={{ alignSelf: 'flex-start', padding: '4px 10px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                  Remove Item
                </button>
              )}
            </div>
          ))}

          {/* ── Auto total preview ── */}
          {(() => {
            const computedTotal = orderItems.reduce((s, i) => s + (Number(i.price) * Number(i.qty || 1)), 0);
            const baseTotal     = form.total !== '' ? Number(form.total) : computedTotal;
            const finalTotal    = baseTotal - promoDiscount;
            return (
              <div style={{ background: '#f0fdf4', border: '1px solid #86efac', padding: '12px 16px', fontSize: 12, color: '#166534' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: promoDiscount > 0 ? 6 : 0 }}>
                  <span>Items total:</span>
                  <strong>₹{computedTotal.toLocaleString('en-IN')}</strong>
                </div>
                {form.total !== '' && Number(form.total) !== computedTotal && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: promoDiscount > 0 ? 6 : 0, color: '#ca8a04' }}>
                    <span>Override total:</span>
                    <strong>₹{Number(form.total).toLocaleString('en-IN')}</strong>
                  </div>
                )}
                {promoDiscount > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                    <span>Discount ({promoCode}):</span>
                    <strong>−₹{promoDiscount.toLocaleString('en-IN')}</strong>
                  </div>
                )}
                {promoDiscount > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #86efac', paddingTop: 6, fontWeight: 700 }}>
                    <span>Final total:</span>
                    <strong>₹{finalTotal.toLocaleString('en-IN')}</strong>
                  </div>
                )}
              </div>
            );
          })()}

          {/* ── Order Settings ── */}
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--grey-dark)', paddingBottom: 8, borderBottom: '1px solid var(--grey)' }}>
            Order Settings
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            <div>
              <label style={label}>Override Total (₹) <span style={{ fontWeight: 400, textTransform: 'none' }}>— leave blank to use auto</span></label>
              <input type="number" value={form.total}
                onChange={e => setForm(p => ({ ...p, total: e.target.value }))}
                placeholder="Auto from items" style={inp}
                onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div>
              <label style={label}>Status</label>
              <select value={form.status} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}
                style={{ ...inp, cursor: 'pointer' }}
                onFocus={e => e.target.style.borderColor = 'var(--dark)'} onBlur={e => e.target.style.borderColor = '#e5e7eb'}>
                {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>

          {/* ── Promo Code ── */}
          <div>
            <label style={label}>Promo Code</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                value={promoCode}
                onChange={e => { setPromoCode(e.target.value.toUpperCase()); setPromoDiscount(0); setPromoError(''); }}
                placeholder="ENTER PROMO CODE"
                style={{ ...inp, flex: 1 }}
                onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'}
              />
              <button
                type="button"
                onClick={handleApplyPromo}
                style={{ padding: '0 18px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}
              >
                Apply
              </button>
            </div>
            {promoError && (
              <div style={{ color: '#dc2626', fontSize: 11, marginTop: 5 }}>{promoError}</div>
            )}
            {promoDiscount > 0 && (
              <div style={{ color: '#16a34a', fontSize: 11, marginTop: 5, fontWeight: 600 }}>
                ✓ {promoCode} applied — ₹{promoDiscount.toLocaleString('en-IN')} OFF
              </div>
            )}
          </div>

          {/* ── Buttons ── */}
          <div style={{ display: 'flex', gap: 12, paddingTop: 8 }}>
            <button type="button" onClick={() => { setShowForm(false); resetForm(); }}
              style={{ ...btn('ghost'), flex: 1 }}>
              Cancel
            </button>
            <button type="submit" disabled={saving}
              style={{ ...btn('gold'), flex: 2, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Saving…' : editing ? 'Update Order' : 'Create Order'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );

  // ════════════════════════════════════════════════
  // ORDERS LIST
  // ════════════════════════════════════════════════
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

      {/* ── Status Toast ── */}
      {statusMsg && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
          padding: '14px 24px',
          background: statusMsg.startsWith('✓') ? '#dcfce7' : '#fee2e2',
          color:      statusMsg.startsWith('✓') ? '#166534' : '#dc2626',
          border:     `1px solid ${statusMsg.startsWith('✓') ? '#86efac' : '#fca5a5'}`,
          fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-body)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.12)', borderRadius: 6, minWidth: 280,
        }}>
          {statusMsg}
        </div>
      )}

      {/* ── Top bar ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <p style={{ fontSize: 13, color: 'var(--grey-dark)', margin: 0 }}>
          <strong>{totalOrders}</strong> total orders
        </p>
        <button onClick={() => { resetForm(); setShowForm(true); }} style={btn('gold')}>
          + Create Order
        </button>
      </div>

      {/* ── Status Tabs ── */}
      <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid var(--grey)', overflowX: 'auto' }}>
        {TABS.map(tab => {
          const count    = tab === 'All' ? orders.length : orders.filter(o => (o.status || '').toLowerCase() === tab.toLowerCase()).length;
          const isActive = activeTab === tab;
          return (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{
              padding: isMobile ? '8px 12px' : '10px 20px',
              background: 'none', border: 'none',
              borderBottom: isActive ? '2px solid var(--dark)' : '2px solid transparent',
              marginBottom: '-2px', cursor: 'pointer',
              fontSize: isMobile ? 11 : 12,
              fontWeight: isActive ? 700 : 400,
              color: isActive ? 'var(--dark)' : 'var(--grey-mid)',
              fontFamily: 'var(--font-body)', whiteSpace: 'nowrap',
              display: 'flex', alignItems: 'center', gap: 4,
            }}>
              {tab}{' '}
              <span style={{
                fontSize: 10, fontWeight: 700, padding: '1px 5px', borderRadius: 10,
                background: isActive ? 'var(--dark)' : '#f3f4f6',
                color:      isActive ? '#fff'        : 'var(--grey-mid)',
              }}>
                {count}
              </span>
            </button>
          );
        })}
      </div>

      {/* ── Table ── */}
      <div style={card}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: isMobile ? 600 : 900 }}>
            <thead>
              <tr>
                {['Order Ref', 'Customer', 'Phone', 'Total', 'Status', 'Date', 'Actions'].map(h => (
                  <th key={h} style={th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(o => {
                const sc = STATUS_COLOR[(o.status || '').toLowerCase()] || { bg: '#f3f4f6', color: '#6b7280' };
                return (
                  <tr key={o.id || o.ref || o.order_ref}
                    style={{ transition: 'background 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={td}><code style={{ fontSize: 11 }}>{o.ref || o.order_ref}</code></td>
                    <td style={td}>{o.customer_name}</td>
                    <td style={td}>{o.customer_phone}</td>
                    <td style={td}>₹{Number(o.total).toLocaleString('en-IN')}</td>
                    {/* <td style={td}>
                      <select value={o.status}
                        onChange={e => handleStatus(o.ref || o.order_ref, e.target.value)}
                        style={{
                          fontSize: 11, border: `1px solid ${sc.color}`, padding: '4px 8px',
                          background: sc.bg, color: sc.color, cursor: 'pointer',
                          outline: 'none', fontFamily: 'var(--font-body)', fontWeight: 600, borderRadius: 4,
                        }}>
                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td> */}
                    <td style={td}>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <select
                          value={o.status}
                          disabled={updatingRef === (o.ref || o.order_ref)}
                          onChange={e => handleStatus(o.ref || o.order_ref, e.target.value)}
                          style={{
                            fontSize: 11, border: `1px solid ${sc.color}`, padding: '4px 8px',
                            background: updatingRef === (o.ref || o.order_ref) ? '#f3f4f6' : sc.bg,
                            color: updatingRef === (o.ref || o.order_ref) ? '#9ca3af' : sc.color,
                            cursor: updatingRef === (o.ref || o.order_ref) ? 'not-allowed' : 'pointer',
                            outline: 'none', fontFamily: 'var(--font-body)', fontWeight: 600, borderRadius: 4,
                            opacity: updatingRef === (o.ref || o.order_ref) ? 0.6 : 1,
                            transition: 'all 0.2s',
                          }}>
                          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                        {updatingRef === (o.ref || o.order_ref) && (
                          <div style={{
                            position: 'absolute', right: -22, top: '50%', transform: 'translateY(-50%)',
                          }}>
                            <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth={2}>
                              <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                              <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
                                style={{ animation: 'spin 1s linear infinite', transformOrigin: 'center' }}/>
                            </svg>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={td}>
                      {o.created_at ? new Date(o.created_at).toLocaleDateString('en-IN') : '—'}
                    </td>
                    <td style={td}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => setViewOrder(o)}
                          style={{ padding: '5px 8px', background: '#f3f4f6', color: 'var(--dark)', border: '1px solid #e5e7eb', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                          View
                        </button>
                        <button onClick={() => openEdit(o)}
                          style={{ padding: '5px 8px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                          Edit
                        </button>
                        <button onClick={() => handleDelete(o.ref || o.order_ref, o.id)}
                          style={{ padding: '5px 8px', background: '#fef2f2', color: 'var(--red)', border: '1px solid #fecaca', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                          Del
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filteredOrders.length === 0 && (
            <p style={{ padding: 32, textAlign: 'center', fontSize: 12, color: 'var(--grey-mid)' }}>
              No {activeTab === 'All' ? '' : activeTab.toLowerCase()} orders on this page.
            </p>
          )}
        </div>
      </div>

      {/* ── Pagination ── */}
      {totalOrders > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <p style={{ fontSize: 12, color: 'var(--grey-mid)', margin: 0 }}>
              Showing <strong>{(page - 1) * LIMIT + 1}</strong>–<strong>{Math.min(page * LIMIT, totalOrders)}</strong> of <strong>{totalOrders}</strong> orders
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, color: 'var(--grey-mid)', whiteSpace: 'nowrap' }}>Rows per page:</span>
              <select
                value={LIMIT}
                onChange={e => { setLimitState(Number(e.target.value)); loadOrders(1, Number(e.target.value)); }}
                style={{ border: '1px solid #e5e7eb', padding: '6px 10px', fontSize: 12, background: '#fff', color: 'var(--dark)', outline: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)', borderRadius: 4 }}>
                {[10, 50, 100, 200, 500].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>

          {totalPages > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
              <button onClick={() => loadOrders(page - 1, LIMIT)} disabled={page <= 1}
                style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', background: page <= 1 ? '#f3f4f6' : '#fff', color: page <= 1 ? '#9ca3af' : 'var(--dark)', cursor: page <= 1 ? 'not-allowed' : 'pointer', fontSize: 14, borderRadius: 4, fontWeight: 600 }}>
                ‹
              </button>

              {(() => {
                const windowSize = 5;
                const half       = Math.floor(windowSize / 2);
                let start        = Math.max(1, page - half);
                let end          = start + windowSize - 1;
                if (end > totalPages) { end = totalPages; start = Math.max(1, end - windowSize + 1); }
                const pages = [];

                if (start > 1) {
                  pages.push(<button key={1} onClick={() => loadOrders(1, LIMIT)} style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', background: page === 1 ? 'var(--dark)' : '#fff', color: page === 1 ? '#fff' : 'var(--dark)', cursor: 'pointer', fontSize: 12, fontWeight: 600, borderRadius: 4 }}>1</button>);
                  if (start > 2) pages.push(<span key="l" style={{ padding: '0 4px', color: 'var(--grey-mid)', lineHeight: '34px' }}>…</span>);
                }
                for (let p = start; p <= end; p++) {
                  const isActive = p === page;
                  pages.push(
                    <button key={p} onClick={() => loadOrders(p, LIMIT)}
                      style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', border: `1px solid ${isActive ? 'var(--dark)' : '#e5e7eb'}`, background: isActive ? 'var(--dark)' : '#fff', color: isActive ? '#fff' : 'var(--dark)', cursor: 'pointer', fontSize: 12, fontWeight: isActive ? 700 : 400, borderRadius: 4 }}
                      onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = '#f3f4f6'; }}
                      onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = '#fff'; }}>
                      {p}
                    </button>
                  );
                }
                if (end < totalPages) {
                  if (end < totalPages - 1) pages.push(<span key="r" style={{ padding: '0 4px', color: 'var(--grey-mid)', lineHeight: '34px' }}>…</span>);
                  pages.push(<button key={totalPages} onClick={() => loadOrders(totalPages, LIMIT)} style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', background: page === totalPages ? 'var(--dark)' : '#fff', color: page === totalPages ? '#fff' : 'var(--dark)', cursor: 'pointer', fontSize: 12, fontWeight: 600, borderRadius: 4 }}>{totalPages}</button>);
                }
                return pages;
              })()}

              <button onClick={() => loadOrders(page + 1, LIMIT)} disabled={page >= totalPages}
                style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', background: page >= totalPages ? '#f3f4f6' : '#fff', color: page >= totalPages ? '#9ca3af' : 'var(--dark)', cursor: page >= totalPages ? 'not-allowed' : 'pointer', fontSize: 14, borderRadius: 4, fontWeight: 600 }}>
                ›
              </button>
            </div>
          )}
        </div>
      )}

      {/* ── View Order Modal ── */}
      {viewOrder && (
        <div onClick={() => setViewOrder(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: isMobile ? 12 : 24 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>

            <div style={{ padding: '20px 24px', borderBottom: '1px solid #f3f0eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 300, color: 'var(--dark)' }}>Order Details</div>
                <div style={{ fontSize: 12, color: 'var(--grey-mid)', marginTop: 2 }}>{viewOrder.ref || viewOrder.order_ref}</div>
              </div>
              <button onClick={() => setViewOrder(null)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 24, color: 'var(--grey-mid)', lineHeight: 1 }}>×</button>
            </div>

            <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 20 }}>

              {/* Status */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--grey-mid)' }}>Status</span>
                {/* <select value={viewOrder.status}
                  onChange={e => handleStatus(viewOrder.ref || viewOrder.order_ref, e.target.value)}
                  style={{
                    fontSize: 12, fontWeight: 700, padding: '5px 12px', borderRadius: 20, cursor: 'pointer',
                    border:      `1px solid ${(STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { color: '#ccc' }).color}`,
                    background:  (STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { bg: '#f3f4f6' }).bg,
                    color:       (STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { color: '#6b7280' }).color,
                    outline: 'none', fontFamily: 'var(--font-body)',
                  }}>
                  {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                </select> */}
                <select
  value={viewOrder.status}
  disabled={updatingRef === (viewOrder.ref || viewOrder.order_ref)}
  onChange={e => handleStatus(viewOrder.ref || viewOrder.order_ref, e.target.value)}
  style={{
    fontSize: 12, fontWeight: 700, padding: '5px 12px', borderRadius: 20, cursor: updatingRef ? 'not-allowed' : 'pointer',
    border: `1px solid ${(STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { color: '#ccc' }).color}`,
    background: updatingRef ? '#f3f4f6' : (STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { bg: '#f3f4f6' }).bg,
    color: updatingRef ? '#9ca3af' : (STATUS_COLOR[(viewOrder.status || '').toLowerCase()] || { color: '#6b7280' }).color,
    opacity: updatingRef ? 0.6 : 1,
    outline: 'none', fontFamily: 'var(--font-body)', transition: 'all 0.2s',
  }}>
  {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
</select>
{updatingRef === (viewOrder.ref || viewOrder.order_ref) && (
  <span style={{ fontSize: 11, color: '#9ca3af', fontStyle: 'italic', marginLeft: 8 }}>
    Sending email…
  </span>
)}
              </div>

              {/* Customer info */}
              <div style={{ background: '#faf8f5', borderRadius: 8, padding: 16 }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--grey-mid)', marginBottom: 12 }}>Customer</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 10 }}>
                  {[
                    { label: 'Name',    value: viewOrder.customer_name    || '—' },
                    { label: 'Phone',   value: viewOrder.customer_phone   || '—' },
                    { label: 'Email',   value: viewOrder.customer_email   || '—' },
                    { label: 'Address', value: viewOrder.customer_address || '—' },
                  ].map(r => (
                    <div key={r.label} style={{ gridColumn: r.label === 'Address' && !isMobile ? 'span 2' : 'span 1' }}>
                      <div style={{ fontSize: 10, color: 'var(--grey-mid)', marginBottom: 2 }}>{r.label}</div>
                      <div style={{ fontSize: 13, color: 'var(--dark)', fontWeight: 500 }}>{r.value}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Items */}
              {(() => {
                let items = viewOrder.items;
                if (typeof items === 'string') { try { items = JSON.parse(items); } catch { items = null; } }
                if (!Array.isArray(items) || items.length === 0) return null;
                return (
                  <div style={{ background: '#faf8f5', borderRadius: 8, padding: 16 }}>
                    <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--grey-mid)', marginBottom: 12 }}>Order Items</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {items.map((item, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: '8px 0', borderBottom: i < items.length - 1 ? '1px solid #ede9e3' : 'none' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 11, color: 'var(--grey-mid)', textTransform: 'uppercase', marginBottom: 2 }}>{item.brand || ''}</div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--dark)' }}>{item.name || '—'}</div>
                            {item.category && <div style={{ fontSize: 11, color: 'var(--grey-mid)' }}>{item.category}</div>}
                          </div>
                          <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            <div style={{ fontSize: 12, color: 'var(--grey-mid)' }}>Qty: {item.qty || 1}</div>
                            {item.price > 0 && (
                              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--dark)' }}>
                                ₹{(Number(item.price) * Number(item.qty || 1)).toLocaleString('en-IN')}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* ── Total breakdown ── */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 10, borderTop: '1px solid #e8e4de' }}>
                {Number(viewOrder.discount) > 0 && (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 12, color: 'var(--grey-mid)' }}>Subtotal</span>
                      <span style={{ fontSize: 12, color: 'var(--grey-mid)' }}>
                        ₹{(Number(viewOrder.total) + Number(viewOrder.discount)).toLocaleString('en-IN')}
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 12, color: '#16a34a' }}>
                        Discount{viewOrder.promo_code ? ` (${viewOrder.promo_code})` : ''}
                        {viewOrder.discount_pct ? ` — ${viewOrder.discount_pct}%` : ''}
                      </span>
                      <span style={{ fontSize: 12, color: '#16a34a' }}>
                        −₹{Number(viewOrder.discount).toLocaleString('en-IN')}
                      </span>
                    </div>
                  </>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--dark)' }}>Total</span>
                  <span style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 300, color: 'var(--dark)' }}>
                    ₹{Number(viewOrder.total).toLocaleString('en-IN')}
                  </span>
                </div>
              </div>

              {/* Modal actions */}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => { setViewOrder(null); openEdit(viewOrder); }}
                  style={{ flex: 1, padding: '10px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600, borderRadius: 6 }}>
                  Edit Order
                </button>
                <button onClick={() => setViewOrder(null)}
                  style={{ flex: 1, padding: '10px', background: '#f3f4f6', color: 'var(--dark)', border: '1px solid #e5e7eb', cursor: 'pointer', fontSize: 12, fontWeight: 600, borderRadius: 6 }}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Enquiries ──────────────────────────────── */
function SectionEnquiries() {
  const [items,setItems]=useState([]); const [showForm,setShowForm]=useState(false); const [editing,setEditing]=useState(null); const [saving,setSaving]=useState(false);
  const isMobile = useIsMobile();
  const [form,setForm]=useState({ name:'',phone:'',email:'',brand:'',model:'',colour:'',budget:'',description:'',status:'new',type:'request' });
  const [filterStatus, setFilterStatus] = useState('all');
  // const displayItems = filterStatus === 'all' ? items : items.filter(e => e.status === filterStatus);
  // const displayItems = filterStatus === 'all' ? items : items.filter(e => (e.status || 'new') === filterStatus);
  const displayItems = filterStatus === 'all' 
  ? items 
  : items.filter(e => (e.status || 'new').toString().toLowerCase().trim() === filterStatus.toLowerCase().trim());
  useEffect(()=>{ getEnquiries().then(d=>setItems(Array.isArray(d)?d:d?.enquiries||[])).catch(()=>{}); },[]);

  function openNew(){ setEditing(null); setForm({name:'',phone:'',email:'',brand:'',model:'',colour:'',budget:'',description:'',status:'new',type:'request'}); setShowForm(true); }
  function openEdit(e){ setEditing(e); setForm({name:e.name||'',phone:e.phone||'',email:e.email||'',brand:e.brand||'',model:e.model||'',colour:e.colour||'',budget:e.budget||'',description:e.description||e.message||'',status:e.status||'new',type:e.type||'request'}); setShowForm(true); }

  async function handleSave(e){ e.preventDefault(); if(!form.name||!form.phone){alert('Name and phone are required');return;} setSaving(true); try{ if(editing){await updateEnquiryStatus(editing.id,form.status); setItems(prev=>prev.map(i=>i.id===editing.id?{...i,...form}:i));}else{await fetch('http://localhost/CODIZN-full-project%20(2)/codizn/backend/index.php?route=enquiry',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)}); const fresh=await getEnquiries().catch(()=>[]); setItems(Array.isArray(fresh)?fresh:fresh?.enquiries||[]);} setShowForm(false); setEditing(null); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);} }
  async function handleStatus(id,status){ await updateEnquiryStatus(id,status); setItems(prev=>prev.map(e=>e.id===id?{...e,status}:e)); }
  async function handleDelete(id){ if(!window.confirm('Delete this enquiry?')) return; await deleteEnquiry(id); setItems(prev=>prev.filter(e=>e.id!==id)); }

  const STATUS_OPTIONS=['new','in_progress','resolved'];
  const STATUS_COLORS={ new:{bg:'#e0f2fe',color:'#0369a1'},in_progress:{bg:'#fef9c3',color:'#a16207'},resolved:{bg:'#dcfce7',color:'#15803d'} };

  if(showForm) return (
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}>
        <button onClick={()=>{setShowForm(false);setEditing(null);}} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button>
        <h2 style={{ fontSize:16,fontWeight:600,color:'var(--dark)' }}>{editing?'Edit Enquiry':'Add New Enquiry'}</h2>
      </div>
      <form onSubmit={handleSave} style={{ maxWidth:640 }}>
        <div style={{ background:'#fff',border:'1px solid #e5e7eb',padding: isMobile ? 20 : 24,borderRadius:2,display:'flex',flexDirection:'column',gap:18 }}>
          <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:12 }}>
            {[{name:'name',label:'Full Name *',type:'text',span:2},{name:'phone',label:'Phone *',type:'text',span:1},{name:'email',label:'Email',type:'email',span:1},{name:'brand',label:'Brand',type:'text',span:1},{name:'model',label:'Model',type:'text',span:1},{name:'colour',label:'Colour',type:'text',span:1},{name:'budget',label:'Budget',type:'text',span:1}].map(f=>(
              <div key={f.name} style={{ gridColumn: (!isMobile&&f.span===2)?'span 2':'span 1' }}>
                <label style={label}>{f.label}</label>
                <input type={f.type} value={form[f.name]} onChange={e=>setForm(p=>({...p,[f.name]:e.target.value}))} style={{ width:'100%',border:'1px solid #e5e7eb',padding:'10px 12px',fontSize:12,outline:'none',fontFamily:'var(--font-body)',color:'var(--dark)',background:'#fafafa',boxSizing:'border-box',transition:'border-color 0.2s' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
              </div>
            ))}
          </div>
          <div><label style={label}>Notes / Message</label><textarea value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} rows={3} style={{ width:'100%',border:'1px solid #e5e7eb',padding:'10px 12px',fontSize:12,outline:'none',fontFamily:'var(--font-body)',color:'var(--dark)',background:'#fafafa',boxSizing:'border-box',resize:'vertical' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          {editing&&<div><label style={label}>Status</label><select value={form.status} onChange={e=>setForm(p=>({...p,status:e.target.value}))} style={{ width:'100%',border:'1px solid #e5e7eb',padding:'10px 12px',fontSize:12,outline:'none',cursor:'pointer',fontFamily:'var(--font-body)',background:'#fafafa' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}>{STATUS_OPTIONS.map(s=><option key={s} value={s}>{s.replace('_',' ')}</option>)}</select></div>}
          <div style={{ display:'flex',gap:12,paddingTop:8 }}><button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ flex:1,padding:'9px 18px',fontSize:11,letterSpacing:'0.15em',textTransform:'uppercase',fontWeight:700,border:'1px solid var(--grey)',cursor:'pointer',background:'transparent',color:'var(--grey-dark)' }}>Cancel</button><button type="submit" disabled={saving} style={{ flex:2,padding:'9px 18px',fontSize:11,letterSpacing:'0.15em',textTransform:'uppercase',fontWeight:700,border:'none',cursor:'pointer',background:'var(--dark)',color:'#fff',opacity:saving?0.7:1 }}>{saving?'Saving…':editing?'Update':'Create'}</button></div>
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      {/* <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{items.length}</strong> enquir{items.length!==1?'ies':'y'}</p>
        <button onClick={openNew} style={{ padding:'9px 18px',fontSize:11,letterSpacing:'0.15em',textTransform:'uppercase',fontWeight:700,border:'none',cursor:'pointer',background:'var(--gold)',color:'#fff' }}>+ Add Enquiry</button>
      </div> */}
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
        <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{items.length}</strong> enquir{items.length!==1?'ies':'y'}</p>
        <div style={{ display:'flex',gap:8,alignItems:'center',flexWrap:'wrap' }}>
          <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{ border:'1px solid #e5e7eb',padding:'8px 12px',fontSize:11,background:'#fff',color:'var(--dark)',outline:'none',cursor:'pointer',fontFamily:'var(--font-body)' }}>
            <option value="all">All Status</option>
            <option value="new">New</option>
            <option value="in_progress">In Progress</option>
            <option value="resolved">Resolved</option>
          </select>
          <button onClick={openNew} style={{ padding:'9px 18px',fontSize:11,letterSpacing:'0.15em',textTransform:'uppercase',fontWeight:700,border:'none',cursor:'pointer',background:'var(--gold)',color:'#fff' }}>+ Add Enquiry</button>
        </div>
      </div>
      <div style={{ background:'#fff',border:'1px solid #e5e7eb',padding: isMobile ? 0 : 24,borderRadius:2 }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%',borderCollapse:'collapse',minWidth:700 }}>
            <thead><tr>{['Name','Phone','Brand / Model','Budget','Status','Date','Actions'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {/* {items.map(e=>{ */}
              {displayItems.map(e => {
                const sc=STATUS_COLORS[e.status]||{bg:'#f3f4f6',color:'#6b7280'};
                return(
                  <tr key={e.id} style={{ transition:'background 0.15s' }} onMouseEnter={ev=>ev.currentTarget.style.background='#f8f9fa'} onMouseLeave={ev=>ev.currentTarget.style.background='transparent'}>
                    <td style={td}><div style={{ fontWeight:600 }}>{e.name}</div>{e.email&&<div style={{ fontSize:11,color:'var(--grey-mid)' }}>{e.email}</div>}</td>
                    <td style={td}><a href={`https://wa.me/91${e.phone?.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" style={{ color:'#16a34a',fontWeight:600,textDecoration:'none' }}>{e.phone}</a></td>
                    <td style={td}>{e.brand&&<div style={{ fontWeight:500 }}>{e.brand}</div>}{e.model&&<div style={{ fontSize:11,color:'var(--grey-mid)' }}>{e.model}</div>}{!e.brand&&!e.model&&'—'}</td>
                    <td style={td}>{e.budget||'—'}</td>
                    <td style={td}><select value={e.status||'new'} onChange={ev=>handleStatus(e.id,ev.target.value)} style={{ fontSize:11,border:'1px solid var(--grey)',padding:'4px 8px',background:sc.bg,color:sc.color,cursor:'pointer',outline:'none',fontWeight:600 }}>{STATUS_OPTIONS.map(s=><option key={s} value={s}>{s.replace('_',' ')}</option>)}</select></td>
                    <td style={td}>{e.created_at?new Date(e.created_at).toLocaleDateString('en-IN',{day:'numeric',month:'short'}):'—'}</td>
                    <td style={td}><div style={{ display:'flex',gap:6 }}><button onClick={()=>openEdit(e)} style={{ padding:'5px 10px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>Edit</button><button onClick={()=>handleDelete(e.id)} style={{ padding:'5px 10px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Del</button></div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {displayItems.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>{filterStatus==='all'?'No enquiries yet.':'No enquiries with this status.'}</p>}
          {/* {items.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No enquiries yet.</p>} */}
        </div>
      </div>
    </div>
  );
}

/* ─── Consignments ───────────────────────────── */
function SectionConsignments() {
  const [items,setItems]=useState([]); const [loading,setLoading]=useState(true); const [viewItem,setViewItem]=useState(null); const [editItem,setEditItem]=useState(null); const [saving,setSaving]=useState(false); const [uploading,setUploading]=useState(false);
  const extraImgRef=useRef();
  const isMobile = useIsMobile();
  const [filterCon, setFilterCon] = useState('all');
  const displayCons = filterCon === 'all' ? items : items.filter(c => (c.status||'Pending') === filterCon);

  const STATUS_OPTIONS=['Pending','Reviewing','Accepted','Rejected'];
  const STATUS_COLORS={ Pending:{bg:'#fef9c3',color:'#a16207'},Reviewing:{bg:'#dbeafe',color:'#1d4ed8'},Accepted:{bg:'#dcfce7',color:'#15803d'},Rejected:{bg:'#fee2e2',color:'#dc2626'} };

  useEffect(()=>{ getConsignments().then(d=>setItems(Array.isArray(d)?d:d?.consignments||[])).catch(()=>{}).finally(()=>setLoading(false)); },[]);

  async function handleStatus(id,status){
    setSaving(true);
    try{ await fetch(`${BASE_URL}/admin_panel.php?section=consignments&id=${id}`,{method:'PATCH',headers:{'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('aurora_admin_token')||''}`},body:JSON.stringify({status})}); setItems(prev=>prev.map(c=>c.id===id?{...c,status}:c)); if(viewItem&&viewItem.id===id)setViewItem(prev=>({...prev,status})); if(editItem&&editItem.id===id)setEditItem(prev=>({...prev,status})); }catch{alert('Error updating status');}finally{setSaving(false);}
  }

  async function handleDelete(id){
    if(!window.confirm('Delete this consignment?')) return;
    try{ await fetch(`${BASE_URL}/admin_panel.php?section=consignments&id=${id}`,{method:'DELETE',headers:{'Authorization':`Bearer ${localStorage.getItem('aurora_admin_token')||''}`}}); setItems(prev=>prev.filter(c=>c.id!==id)); if(viewItem?.id===id)setViewItem(null); }catch{alert('Delete failed');}
  }

  function openEdit(c){ setEditItem({...c,_images:parseImages(c.images)}); setViewItem(null); }

  async function handleEditImages(e){
    const files=Array.from(e.target.files||[]); const remaining=6-(editItem._images?.length||0); const toUpload=files.slice(0,remaining); if(!toUpload.length) return;
    setUploading(true); try{ const urls=await Promise.all(toUpload.map(f=>uploadImage(f).then(r=>r.url||r.path||r.file))); setEditItem(prev=>({...prev,_images:[...(prev._images||[]),...urls]})); }catch{alert('Image upload failed');}finally{setUploading(false);e.target.value='';}
  }

  async function handleEditSave(e){
    e.preventDefault(); setSaving(true);
    try{
      const payload={name:editItem.name||'',phone:editItem.phone||'',email:editItem.email||'',brand:editItem.brand||'',model:editItem.model||'',condition:editItem.condition||'',asking_price:editItem.asking_price||null,offer_price:editItem.offer_price||null,notes:editItem.notes||'',status:editItem.status||'Pending',images:(editItem._images||[]).join(',')};
      await fetch(`${BASE_URL}/admin_panel.php?section=consignments&id=${editItem.id}`,{method:'PUT',headers:{'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('aurora_admin_token')||''}`},body:JSON.stringify(payload)});
      setItems(prev=>prev.map(c=>c.id===editItem.id?{...c,...payload}:c)); setEditItem(null);
    }catch(err){alert('Save failed: '+err.message);}finally{setSaving(false);}
  }

  function parseImages(f){ if(!f) return []; if(Array.isArray(f)) return f; return f.split(',').map(s=>s.trim()).filter(Boolean); }

  if(editItem) return (
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}>
        <button onClick={()=>setEditItem(null)} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button>
        <h2 style={{ fontSize:16,fontWeight:600,color:'var(--dark)' }}>Edit Consignment #{editItem.id}</h2>
      </div>
      <form onSubmit={handleEditSave}>
        <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:24 }}>
          <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
            <div style={card}>
              <h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:12,textTransform:'uppercase',letterSpacing:'0.1em' }}>Photos ({editItem._images.length}/6)</h3>
              <div style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:12 }}>
                {editItem._images.map((img,i)=>(
                  <div key={i} style={{ position:'relative',aspectRatio:'1',overflow:'hidden',background:'#e8e4de' }}>
                    <img src={imgSrc(img)} alt={`Photo ${i+1}`} style={{ width:'100%',height:'100%',objectFit:'cover',display:'block' }}/>
                    {i===0&&<div style={{ position:'absolute',bottom:4,left:4,fontSize:9,background:'var(--gold)',color:'#fff',padding:'2px 6px',fontWeight:700 }}>MAIN</div>}
                    <button type="button" onClick={()=>setEditItem(prev=>({...prev,_images:prev._images.filter((_,idx)=>idx!==i)}))} style={{ position:'absolute',top:4,right:4,width:22,height:22,borderRadius:'50%',background:'rgba(239,68,68,0.9)',border:'none',cursor:'pointer',color:'#fff',fontSize:13,display:'flex',alignItems:'center',justifyContent:'center' }}>×</button>
                  </div>
                ))}
                {editItem._images.length<6&&<div onClick={()=>extraImgRef.current?.click()} style={{ aspectRatio:'1',border:'2px dashed var(--grey)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:24,color:'var(--grey-mid)',background:'#faf8f5' }}>{uploading?'…':'+'}</div>}
              </div>
              <input ref={extraImgRef} type="file" accept="image/*" multiple hidden onChange={handleEditImages}/>
            </div>
            <div style={card}><h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:12,textTransform:'uppercase' }}>Notes</h3><textarea value={editItem.notes||''} onChange={e=>setEditItem(prev=>({...prev,notes:e.target.value}))} rows={5} style={{ ...inp,resize:'vertical' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          </div>
          <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
            <div style={card}>
              <h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:12,textTransform:'uppercase' }}>Status</h3>
              <div style={{ display:'flex',gap:8,flexWrap:'wrap' }}>
                {STATUS_OPTIONS.map(s=>{ const c=STATUS_COLORS[s]; const active=editItem.status===s; return(<button key={s} type="button" onClick={()=>setEditItem(prev=>({...prev,status:s}))} style={{ padding:'8px 18px',fontSize:11,fontWeight:700,cursor:'pointer',border:`2px solid ${active?c.color:'#e5e7eb'}`,background:active?c.bg:'#fff',color:active?c.color:'var(--grey-mid)',letterSpacing:'0.08em',transition:'all 0.15s' }}>{s}</button>); })}
              </div>
            </div>
            <div style={card}>
              <h3 style={{ fontSize:12,fontWeight:700,color:'var(--dark)',marginBottom:16,textTransform:'uppercase' }}>Item Details</h3>
              <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:12 }}>
                {[{field:'brand',lbl:'Brand *',span:2},{field:'model',lbl:'Model *',span:2},{field:'condition',lbl:'Condition',span:1,type:'select',options:['New with tags','New without tags','Like New','Excellent','Very Good','Good','Fair']},{field:'asking_price',lbl:'Asking Price (₹)',span:1,type:'number'},{field:'offer_price',lbl:'Offer Price (₹)',span:1,type:'number'},{field:'name',lbl:'Customer Name *',span:2},{field:'phone',lbl:'Phone',span:1},{field:'email',lbl:'Email',span:1,type:'email'}].map(({field,lbl,span,type='text',options})=>(
                  <div key={field} style={{ gridColumn: `span ${isMobile ? 1 : span}` }}>
                    <label style={label}>{lbl}</label>
                    {type==='select' ? <select value={editItem[field]||''} onChange={e=>setEditItem(prev=>({...prev,[field]:e.target.value}))} style={{ ...inp,cursor:'pointer' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}>{options.map(o=><option key={o} value={o}>{o}</option>)}</select> : <input type={type} value={editItem[field]||''} onChange={e=>setEditItem(prev=>({...prev,[field]:e.target.value}))} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>}
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display:'flex',gap:12 }}><button type="button" onClick={()=>setEditItem(null)} style={{ ...btn('ghost'),flex:1 }}>Cancel</button><button type="submit" disabled={saving||uploading} style={{ ...btn('gold'),flex:2,opacity:(saving||uploading)?0.7:1 }}>{saving?'Saving…':uploading?'Uploading…':'Save Changes'}</button></div>
          </div>
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      {/* <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
        <div>
          <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{items.length}</strong> consignment request{items.length!==1?'s':''}</p>
        </div>
        <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
          {STATUS_OPTIONS.map(s=>{ const sc=STATUS_COLORS[s]; const count=items.filter(c=>(c.status||'Pending')===s).length; return(<span key={s} style={{ fontSize:10,fontWeight:600,padding:'4px 10px',background:sc.bg,color:sc.color }}>{s} ({count})</span>); })}
        </div>
      </div> */}
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
  <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{items.length}</strong> consignment request{items.length!==1?'s':''}</p>
  <div style={{ display:'flex',gap:8,alignItems:'center',flexWrap:'wrap' }}>
    {STATUS_OPTIONS.map(s=>{ const sc=STATUS_COLORS[s]; const count=items.filter(c=>(c.status||'Pending')===s).length; return(
      <button key={s} onClick={()=>setFilterCon(filterCon===s?'all':s)} style={{ fontSize:10,fontWeight:600,padding:'5px 12px',background:filterCon===s?sc.color:sc.bg,color:filterCon===s?'#fff':sc.color,border:`1px solid ${sc.color}`,cursor:'pointer',transition:'all 0.15s' }}>{s} ({count})</button>
    );})}
    {filterCon!=='all'&&<button onClick={()=>setFilterCon('all')} style={{ fontSize:10,color:'var(--grey-mid)',background:'none',border:'none',cursor:'pointer',fontWeight:600 }}>✕ Clear</button>}
  </div>
</div>
      <div style={{ background:'#fff',border:'1px solid #e5e7eb',overflow:'hidden' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%',borderCollapse:'collapse',minWidth:700 }}>
            <thead><tr style={{ background:'#faf8f5' }}>{['Customer','Brand / Model','Condition','Asking Price','Status','Date','Actions'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {loading&&<tr><td colSpan="7" style={{ padding:40,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>Loading…</td></tr>}
              {!loading&&displayCons.length===0&&<tr><td colSpan="7" style={{ padding:40,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No consignment requests yet.</td></tr>}
              {!loading&&displayCons.map(c=>{ const statusKey=c.status||'Pending'; const sc=STATUS_COLORS[statusKey]||{bg:'#f3f4f6',color:'#6b7280'}; return(
                <tr key={c.id} style={{ transition:'background 0.15s' }} onMouseEnter={e=>e.currentTarget.style.background='#faf8f5'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <td style={td}><div style={{ fontWeight:600 }}>{c.name}</div><a href={`https://wa.me/91${c.phone?.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" style={{ color:'#16a34a',fontSize:11,textDecoration:'none',fontWeight:500 }}>{c.phone}</a></td>
                  <td style={td}><div style={{ fontWeight:600 }}>{c.brand}</div><div style={{ fontSize:11,color:'var(--grey-mid)' }}>{c.model}</div></td>
                  <td style={td}>{c.condition||'—'}</td>
                  <td style={td}>{c.asking_price?`₹${Number(c.asking_price).toLocaleString('en-IN')}`:'—'}</td>
                  <td style={td}><select value={statusKey} onChange={e=>handleStatus(c.id,e.target.value)} style={{ fontSize:11,border:`1px solid ${sc.color}`,padding:'4px 8px',background:sc.bg,color:sc.color,cursor:'pointer',outline:'none',fontWeight:600,borderRadius:4 }}>{STATUS_OPTIONS.map(s=><option key={s} value={s}>{s}</option>)}</select></td>
                  <td style={td}>{c.created_at?new Date(c.created_at).toLocaleDateString('en-IN',{day:'numeric',month:'short'}):'—'}</td>
                  <td style={td}><div style={{ display:'flex',gap:6 }}><button onClick={()=>setViewItem(c)} style={{ padding:'5px 8px',background:'#f3f4f6',color:'var(--dark)',border:'1px solid #e5e7eb',cursor:'pointer',fontSize:11,fontWeight:600 }}>View</button><button onClick={()=>openEdit(c)} style={{ padding:'5px 8px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>Edit</button><button onClick={()=>handleDelete(c.id)} style={{ padding:'5px 8px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Del</button></div></td>
                </tr>
              );})}
            </tbody>
          </table>
        </div>
      </div>
      {viewItem&&(()=>{ const imgs=parseImages(viewItem.images); const statusKey=viewItem.status||'Pending'; const sc=STATUS_COLORS[statusKey]||{bg:'#f3f4f6',color:'#6b7280'}; return(
        <div onClick={()=>setViewItem(null)} style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding: isMobile ? 12 : 24 }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:'#fff',width:'100%',maxWidth:700,maxHeight:'92vh',overflowY:'auto',boxShadow:'0 24px 80px rgba(0,0,0,0.4)' }}>
            <div style={{ padding:'18px 24px',borderBottom:'1px solid #f3f0eb',display:'flex',alignItems:'center',justifyContent:'space-between',background:'var(--dark)' }}>
              <div><div style={{ fontFamily:'var(--font-display)',fontSize:18,fontWeight:300,color:'#fff' }}>{viewItem.brand} — {viewItem.model}</div><div style={{ fontSize:11,color:'rgba(255,255,255,0.4)',marginTop:2 }}>Request #{viewItem.id}</div></div>
              <button onClick={()=>setViewItem(null)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:26,color:'rgba(255,255,255,0.5)',lineHeight:1,padding:0 }}>×</button>
            </div>
            <div style={{ padding: isMobile ? 16 : 24,display:'flex',flexDirection:'column',gap:20 }}>
              <div style={{ display:'flex',alignItems:'center',gap:12,flexWrap:'wrap' }}>
                <span style={{ fontSize:10,fontWeight:700,letterSpacing:'0.12em',textTransform:'uppercase',color:'var(--grey-mid)' }}>Status</span>
                <select value={statusKey} onChange={e=>handleStatus(viewItem.id,e.target.value)} style={{ fontSize:12,fontWeight:700,padding:'6px 14px',border:`1px solid ${sc.color}`,background:sc.bg,color:sc.color,cursor:'pointer',outline:'none',borderRadius:4 }}>{STATUS_OPTIONS.map(s=><option key={s} value={s}>{s}</option>)}</select>
              </div>
              {imgs.length>0&&<div style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8 }}>{imgs.map((img,i)=><div key={i} style={{ aspectRatio:'1',overflow:'hidden',background:'#e8e4de',cursor:'pointer' }} onClick={()=>window.open(imgSrc(img),'_blank')}><img src={imgSrc(img)} alt="" style={{ width:'100%',height:'100%',objectFit:'cover',display:'block' }}/></div>)}</div>}
              <div style={{ display:'flex',gap:10,flexWrap:'wrap' }}>
                <button onClick={()=>{setViewItem(null);openEdit(viewItem);}} style={{ flex:1,padding:'11px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:700,textTransform:'uppercase' }}>✎ Edit</button>
                {viewItem.status!=='Accepted'&&<button onClick={()=>handleStatus(viewItem.id,'Accepted')} style={{ flex:1,padding:'11px',background:'#dcfce7',color:'#15803d',border:'1px solid #86efac',cursor:'pointer',fontSize:11,fontWeight:700,textTransform:'uppercase' }}>✓ Accept</button>}
                {viewItem.status!=='Rejected'&&<button onClick={()=>handleStatus(viewItem.id,'Rejected')} style={{ flex:1,padding:'11px',background:'#fee2e2',color:'#dc2626',border:'1px solid #fca5a5',cursor:'pointer',fontSize:11,fontWeight:700,textTransform:'uppercase' }}>✕ Reject</button>}
                <button onClick={()=>setViewItem(null)} style={{ flex:1,padding:'11px',background:'#f3f4f6',color:'var(--grey-dark)',border:'1px solid #e5e7eb',cursor:'pointer',fontSize:11,fontWeight:700,textTransform:'uppercase' }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      );})()} 
    </div>
  );
}

/* ─── Blogs ──────────────────────────────────── */
function SectionBlogs() {
  const [blogs,setBlogs]=useState([]); const [editing,setEditing]=useState(null); const [showForm,setShowForm]=useState(false);
  const [form,setForm]=useState({title:'',slug:'',category:'',excerpt:'',content:'',image:'',published:true});
  const fileRef=useRef(); const [uploading,setUploading]=useState(false); const [saving,setSaving]=useState(false);
  const isMobile = useIsMobile();

  useEffect(()=>{ fetchBlogs().then(b=>setBlogs(Array.isArray(b)?b:[])).catch(()=>{}); },[]);

  function openNew(){ setEditing(null); setForm({title:'',slug:'',category:'',excerpt:'',content:'',image:'',published:true}); setShowForm(true); }
  function openEdit(b){ setEditing(b); setForm({title:b.title||'',slug:b.slug||'',category:b.category||'',excerpt:b.excerpt||'',content:b.content||'',image:b.image||'',published:b.published!==false}); setShowForm(true); }

  async function handleUpload(e){ const file=e.target.files?.[0]; if(!file) return; setUploading(true); try{const res=await uploadImage(file);setForm(f=>({...f,image:res.url||res.path||res.file}));}catch{alert('Upload failed');}finally{setUploading(false);} }

  async function handleSave(e){
    e.preventDefault(); setSaving(true);
    try{ const slug=form.slug||form.title.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); const data={...form,slug}; if(editing){await updateBlog(editing.id,data);setBlogs(prev=>prev.map(b=>b.id===editing.id?{...b,...data}:b));}else{const created=await createBlog(data);setBlogs(prev=>[created,...prev]);} setShowForm(false); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);}
  }

  async function handleDelete(id){ if(!window.confirm('Delete blog post?')) return; await deleteBlog(id); setBlogs(prev=>prev.filter(b=>b.id!==id)); }

  if(showForm) return (
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}><button onClick={()=>setShowForm(false)} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button><h2 style={{ fontSize:16,fontWeight:600 }}>{editing?'Edit Post':'New Post'}</h2></div>
      <form onSubmit={handleSave} style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:24 }}>
        <div style={{ ...card,display:'flex',flexDirection:'column',gap:14 }}>
          {[{name:'title',label:'Title *',type:'text'},{name:'slug',label:'Slug',type:'text'},{name:'category',label:'Category',type:'text'},{name:'excerpt',label:'Excerpt',type:'text'}].map(({name:n,label:l,type:t})=>(<div key={n}><label style={label}>{l}</label><input name={n} type={t} value={form[n]} onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>))}
          <div><label style={label}>Content *</label><textarea name="content" value={form.content} onChange={e=>setForm(f=>({...f,content:e.target.value}))} rows={10} style={{ ...inp,resize:'vertical' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
        </div>
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div style={card}><label style={label}>Cover Image</label><div style={{ border:'2px dashed var(--grey)',padding:16,textAlign:'center',cursor:'pointer',marginBottom:8 }} onClick={()=>fileRef.current?.click()}>{form.image?<img src={imgSrc(form.image)||form.image} alt="" style={{ maxHeight:150,maxWidth:'100%',objectFit:'cover' }}/>:<p style={{ fontSize:12,color:'var(--grey-mid)' }}>{uploading?'Uploading…':'Click to upload'}</p>}</div><input ref={fileRef} type="file" accept="image/*" style={{ display:'none' }} onChange={handleUpload}/><input value={form.image} onChange={e=>setForm(f=>({...f,image:e.target.value}))} placeholder="Or paste URL" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div style={card}><label style={{ ...label,marginBottom:10 }}>Published</label><button type="button" onClick={()=>setForm(f=>({...f,published:!f.published}))} style={{ width:'100%',padding:'10px',border:`2px solid ${form.published?'var(--green)':'var(--grey)'}`,background:form.published?'#dcfce7':'#fff',color:form.published?'var(--green)':'var(--grey-dark)',fontSize:12,fontWeight:600,cursor:'pointer' }}>{form.published?'✓ Published':'Draft'}</button></div>
          <div style={{ display:'flex',gap:12 }}><button type="button" onClick={()=>setShowForm(false)} style={{ ...btn('ghost'),flex:1 }}>Cancel</button><button type="submit" disabled={saving} style={{ ...btn('dark'),flex:2,opacity:saving?0.7:1 }}>{saving?'Saving…':editing?'Update':'Publish'}</button></div>
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <div style={{ display:'flex',justifyContent:'flex-end' }}><button onClick={openNew} style={btn('gold')}>+ New Post</button></div>
      <div style={card}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%',borderCollapse:'collapse',minWidth:500 }}>
            <thead><tr>{['Title','Category','Published','Date',''].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {blogs.map(b=>(
                <tr key={b.id}>
                  <td style={td}>{b.image&&<img src={imgSrc(b.image)||b.image} alt="" style={{ width:40,height:40,objectFit:'cover',marginRight:10,verticalAlign:'middle' }}/>}<strong>{b.title}</strong></td>
                  <td style={td}>{b.category||'—'}</td>
                  <td style={td}><span style={{ background:b.published?'#dcfce7':'#f3f4f6',color:b.published?'var(--green)':'var(--grey-dark)',fontSize:10,fontWeight:700,padding:'3px 8px' }}>{b.published?'Live':'Draft'}</span></td>
                  <td style={td}>{new Date(b.created_at||Date.now()).toLocaleDateString('en-IN')}</td>
                  <td style={td}><div style={{ display:'flex',gap:8 }}><button onClick={()=>openEdit(b)} style={{ padding:'6px 12px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>Edit</button><button onClick={()=>handleDelete(b.id)} style={{ padding:'6px 12px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Del</button></div></td>
                </tr>
              ))}
            </tbody>
          </table>
          {blogs.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No blog posts yet.</p>}
        </div>
      </div>
    </div>
  );
}

/* ─── Contacts ───────────────────────────────── */
function SectionContacts() {
  const [items,setItems]=useState([]);
  useEffect(()=>{ getContacts().then(d=>setItems(Array.isArray(d)?d:d?.contacts||[])).catch(()=>{}); },[]);
  async function handleStatus(id,status){ await updateContactStatus(id,status); setItems(prev=>prev.map(c=>c.id===id?{...c,status}:c)); }
  return(
    <div style={card}><div style={{ overflowX:'auto' }}><table style={{ width:'100%',borderCollapse:'collapse',minWidth:600 }}><thead><tr>{['Name','Email','Phone','Subject','Status','Date'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead><tbody>{items.map(c=>(<tr key={c.id}><td style={td}>{c.name}</td><td style={td}>{c.email}</td><td style={td}>{c.phone}</td><td style={td}>{c.subject||'—'}</td><td style={td}><select value={c.status||'new'} onChange={e=>handleStatus(c.id,e.target.value)} style={{ fontSize:11,border:'1px solid var(--grey)',padding:'4px 8px',background:'#fff',cursor:'pointer',outline:'none' }}>{['new','read','replied'].map(s=><option key={s} value={s}>{s}</option>)}</select></td><td style={td}>{new Date(c.created_at).toLocaleDateString('en-IN')}</td></tr>))}</tbody></table>{items.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No contact submissions yet.</p>}</div></div>
  );
}

/* ─── Promo Codes ────────────────────────────── */
function SectionPromo() {
  const [codes, setCodes] = useState([]);
  const [page, setPage]             = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCodes, setTotalCodes] = useState(0);
  const [LIMIT, setLimitState]      = useState(10);
  const [saving, setSaving] = useState(false);
  const [editingCode, setEditingCode] = useState(null); // holds code being edited
  const [form, setForm] = useState({
    code: '', discount: 10, expires_at: '', max_uses: '',
    brand: '', category: '', product_id: ''
  });
  const [editForm, setEditForm] = useState({
    code: '', discount: 10, expires_at: '', max_uses: '',
    brand: '', category: '', product_id: ''
  });
  const isMobile = useIsMobile();
  const [promoBrands, setPromoBrands] = useState([]);
  const [promoCategories, setPromoCategories] = useState([]);

  // useEffect(() => {
  //   getPromoCodes()
  //     .then(d => setCodes(Array.isArray(d) ? d : d?.codes || []))
  //     .catch(() => {});
  //   getBrands().then(d => setPromoBrands(Array.isArray(d) ? d : [])).catch(() => {});
  //   getCategories().then(d => setPromoCategories(Array.isArray(d) ? d : [])).catch(() => {});
  // }, []);
  function loadPromoCodes(p = 1, limit = LIMIT) {
    getPromoCodes(p, limit)
      .then(d => {
        setCodes(Array.isArray(d) ? d : d?.codes || []);
        setPage(d?.page || p);
        setTotalPages(d?.total_pages || 1);
        setTotalCodes(d?.total || 0);
      })
      .catch(() => {});
  }

  useEffect(() => {
    loadPromoCodes(1, 10);

    getBrands()
      .then(d => setPromoBrands(Array.isArray(d) ? d : []))
      .catch(() => {});

    getCategories()
      .then(d => setPromoCategories(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  async function handleCreate(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await createPromoCode({
        ...form,
        discount_pct: Number(form.discount),
        discount: undefined,
        max_uses: form.max_uses ? Number(form.max_uses) : null,
        brand: form.brand || null,
        category: form.category || null,
        sku: form.product_id || null,
      });
      const fresh = await getPromoCodes();
      setCodes(Array.isArray(fresh) ? fresh : fresh?.codes || []);
      setForm({ code: '', discount: 10, expires_at: '', max_uses: '', brand: '', category: '', product_id: '' });
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Delete promo code?')) return;
    await deletePromoCode(id);
    setCodes(prev => prev.filter(c => c.id !== id));
  }

  // ── Toggle active/inactive ──
  async function handleToggleActive(code) {
    const newActive = code.active ? 0 : 1;
    try {
      await fetch(`${BASE_URL}/admin_panel.php?section=promo&id=${code.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('aurora_admin_token') || ''}`
        },
        body: JSON.stringify({ active: newActive })
      });
      setCodes(prev => prev.map(c => c.id === code.id ? { ...c, active: newActive } : c));
    } catch (err) {
      alert('Failed to update: ' + err.message);
    }
  }

  // ── Open edit modal ──
  function openEdit(code) {
    setEditingCode(code);
    setEditForm({
      code: code.code || '',
      discount: code.discount_pct || 10,
      expires_at: code.expires_at ? code.expires_at.slice(0, 10) : '',
      max_uses: code.max_uses || '',
      brand: code.brand || '',
      category: code.category || '',
      product_id: code.sku || ''
    });
  }

  // ── Save edited code ──
  async function handleEditSave(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await fetch(`${BASE_URL}/admin_panel.php?section=promo&id=${editingCode.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('aurora_admin_token') || ''}`
        },
        body: JSON.stringify({
          discount_pct: Number(editForm.discount),
          max_uses: editForm.max_uses ? Number(editForm.max_uses) : 0,
          active: editingCode.active
        })
      });
      setCodes(prev => prev.map(c =>
        c.id === editingCode.id
          ? { ...c, discount_pct: Number(editForm.discount), max_uses: editForm.max_uses || null }
          : c
      ));
      setEditingCode(null);
    } catch (err) {
      alert('Update failed: ' + err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      {/* ── Edit Modal ── */}
      {editingCode && (
        <div
          onClick={() => setEditingCode(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 440,
              padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--dark)', margin: 0 }}>
                Edit Promo Code
              </h3>
              <button onClick={() => setEditingCode(null)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: 'var(--grey-mid)', lineHeight: 1 }}>×</button>
            </div>

            <form onSubmit={handleEditSave} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

              {/* Code (read-only) */}
              <div>
                <label style={label}>Code</label>
                <input value={editingCode.code} disabled
                  style={{ ...inp, background: '#f3f4f6', color: 'var(--grey-mid)', cursor: 'not-allowed' }} />
              </div>

              {/* Discount % */}
              <div>
                <label style={label}>Discount % *</label>
                <input type="number" value={editForm.discount}
                  onChange={e => setEditForm(f => ({ ...f, discount: e.target.value }))}
                  style={inp}
                  onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>

              {/* Max Uses */}
              <div>
                <label style={label}>Max Uses</label>
                <input type="number" value={editForm.max_uses}
                  onChange={e => setEditForm(f => ({ ...f, max_uses: e.target.value }))}
                  placeholder="Unlimited"
                  style={inp}
                  onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>

              <div style={{ display: 'flex', gap: 12, paddingTop: 8 }}>
                <button type="button" onClick={() => setEditingCode(null)}
                  style={{ ...btn('ghost'), flex: 1 }}>Cancel</button>
                <button type="submit" disabled={saving}
                  style={{ ...btn('gold'), flex: 2, opacity: saving ? 0.7 : 1 }}>
                  {saving ? 'Saving…' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 24, alignItems: 'start' }}>

        {/* ── Create Form (unchanged) ── */}
        <div style={card}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 20, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--dark)' }}>
            Create Promo Code
          </h3>
          {/* <form onSubmit={handleCreate} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <button type="submit" disabled={saving} style={{ ...btn('gold'), opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Creating…' : 'Create Code'}
            </button>
          </form> */}
                  <form onSubmit={handleCreate} style={{ display:'flex',flexDirection:'column',gap:14 }}>
          {/* {[{name:'code',label:'Code *',type:'text',placeholder:'AURORA20'},{name:'discount',label:'Discount % *',type:'number',placeholder:'10'},{name:'expires_at',label:'Expires',type:'date'},{name:'max_uses',label:'Max Uses',type:'number',placeholder:'100'}].map(({name,label:lbl,type,placeholder})=>(<div key={name}><label style={label}>{lbl}</label><input name={name} type={type} value={form[name]} onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))} placeholder={placeholder} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>))} */}
          <div>
  <label style={label}>Code *</label>
  <input
    name="code"
    type="text"
    value={form.code}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    placeholder="AURORA20"
    style={inp}
  />
</div>

<div>
  <label style={label}>Discount % *</label>
  <input
    name="discount"
    type="number"
    value={form.discount}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    placeholder="10"
    style={inp}
  />
</div>

<div>
  <label style={label}>Brand</label>
  <select
    name="brand"
    value={form.brand}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    style={inp}
  >
    <option value="">All Brands</option>
    {promoBrands.map(b => (
      <option key={b.id} value={b.name}>
        {b.name}
      </option>

    ))}
  </select>
</div>

<div>
  <label style={label}>Category</label>
  <select
    name="category"
    value={form.category}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    style={inp}
  >
    <option value="">All Categories</option>
    {promoCategories.map(c => (
      <option key={c.id} value={c.name}>
        {c.name}
      </option>
    ))}
  </select>
</div>

{/* <div>
  <label style={label}>Product ID</label>
  <input
    name="product_id"
    type="text"
    value={form.product_id}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    placeholder="42"
    style={inp}
  />
</div> */}
<div>
  <label style={label}>Product SKU</label>
  <input
    name="product_id"
    type="text"
    value={form.product_id}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    placeholder="SKU123"
    style={inp}
  />
</div>

<div>
  <label style={label}>Expires</label>
  <input
    name="expires_at"
    type="date"
    value={form.expires_at}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    style={inp}
  />
</div>

<div>
  <label style={label}>Max Uses</label>
  <input
    name="max_uses"
    type="number"
    value={form.max_uses}
    onChange={e=>setForm(f=>({...f,[e.target.name]:e.target.value}))}
    placeholder="100"
    style={inp}
  />
</div>
          <button type="submit" disabled={saving} style={{ ...btn('gold'),opacity:saving?0.7:1 }}>{saving?'Creating…':'Create Code'}</button>
        </form>
        </div>

        {/* ── Active Codes list ── */}
        <div style={card}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--dark)' }}>
            Promo Codes
          </h3>
          {codes.length === 0 ? (
            <p style={{ fontSize: 12, color: 'var(--grey-mid)' }}>No promo codes yet.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {codes.map(c => (
                <div key={c.id || c.code}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 16px',
                    background: c.active ? 'var(--cream)' : '#f9f9f9',
                    border: '1px solid var(--grey)',
                    opacity: c.active ? 1 : 0.55,
                    gap: 8, flexWrap: 'wrap'
                  }}
                >
                  <div>
                    <code style={{ fontSize: 13, fontWeight: 700, color: 'var(--dark)', letterSpacing: '0.1em' }}>
                      {c.code}
                    </code>
                    <div style={{ fontSize: 11, color: 'var(--grey-mid)', marginTop: 2 }}>
                      {c.discount_pct}% off · {c.used_count || 0}/{c.max_uses || '∞'} uses
                      {c.brand && <span> · {c.brand}</span>}
                      {c.category && <span> · {c.category}</span>}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      <span style={{
                        fontSize: 10, fontWeight: 700, padding: '2px 8px',
                        background: c.active ? '#dcfce7' : '#fee2e2',
                        color: c.active ? '#16a34a' : '#dc2626'
                      }}>
                        {c.active ? 'ACTIVE' : 'INACTIVE'}
                      </span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 6, flexShrink: 0, flexWrap: 'wrap' }}>
                    {/* Edit */}
                    <button onClick={() => openEdit(c)}
                      style={{ padding: '5px 10px', background: 'var(--dark)', color: '#fff',
                        border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                      Edit
                    </button>
                    {/* Toggle Active */}
                    <button onClick={() => handleToggleActive(c)}
                      style={{
                        padding: '5px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
                        border: 'none',
                        background: c.active ? '#fef3c7' : '#dcfce7',
                        color: c.active ? '#92400e' : '#166534'
                      }}>
                      {c.active ? 'Deactivate' : 'Activate'}
                    </button>
                    {/* Delete */}
                    <button onClick={() => handleDelete(c.id)}
                      style={{ padding: '5px 10px', background: '#fef2f2', color: 'var(--red)',
                        border: '1px solid #fecaca', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                      Del
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* ── Pagination ── */}
{totalCodes > 0 && (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 18 }}>

    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12
    }}>
      <p style={{ fontSize: 12, color: 'var(--grey-mid)', margin: 0 }}>
        Showing <strong>{(page - 1) * LIMIT + 1}</strong>–
        <strong>{Math.min(page * LIMIT, totalCodes)}</strong> of{' '}
        <strong>{totalCodes}</strong> promo codes
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 11, color: 'var(--grey-mid)' }}>
          Rows per page:
        </span>

        <select
          value={LIMIT}
          onChange={e => {
            setLimitState(Number(e.target.value));
            loadPromoCodes(1, Number(e.target.value));
          }}
          style={{
            border: '1px solid #e5e7eb',
            padding: '6px 10px',
            fontSize: 12,
            background: '#fff',
            color: 'var(--dark)',
            outline: 'none',
            cursor: 'pointer',
            borderRadius: 4
          }}
        >
          {[10, 50, 100, 200].map(n => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>
    </div>

    {totalPages > 1 && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>

        <button
          onClick={() => loadPromoCodes(page - 1, LIMIT)}
          disabled={page <= 1}
          style={{
            width: 34,
            height: 34,
            border: '1px solid #e5e7eb',
            background: page <= 1 ? '#f3f4f6' : '#fff',
            color: page <= 1 ? '#9ca3af' : 'var(--dark)',
            cursor: page <= 1 ? 'not-allowed' : 'pointer',
            borderRadius: 4
          }}
        >
          ‹
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => {
          const isActive = p === page;

          return (
            <button
              key={p}
              onClick={() => loadPromoCodes(p, LIMIT)}
              style={{
                width: 34,
                height: 34,
                border: `1px solid ${isActive ? 'var(--dark)' : '#e5e7eb'}`,
                background: isActive ? 'var(--dark)' : '#fff',
                color: isActive ? '#fff' : 'var(--dark)',
                cursor: 'pointer',
                borderRadius: 4,
                fontWeight: isActive ? 700 : 400
              }}
            >
              {p}
            </button>
          );
        })}

        <button
          onClick={() => loadPromoCodes(page + 1, LIMIT)}
          disabled={page >= totalPages}
          style={{
            width: 34,
            height: 34,
            border: '1px solid #e5e7eb',
            background: page >= totalPages ? '#f3f4f6' : '#fff',
            color: page >= totalPages ? '#9ca3af' : 'var(--dark)',
            cursor: page >= totalPages ? 'not-allowed' : 'pointer',
            borderRadius: 4
          }}
        >
          ›
        </button>

      </div>
    )}
  </div>
)}
      </div>
    </>
  );
}

/* ─── Newsletter ─────────────────────────────── */
// function SectionNewsletter() {
//   const [subs,setSubs]=useState([]);
//   useEffect(()=>{ getNewsletterList().then(d=>setSubs(Array.isArray(d)?d:d?.subscribers||[])).catch(()=>{}); },[]);
//   function copyAll(){ navigator.clipboard.writeText(subs.map(s=>s.email).join('\n')).then(()=>alert('Emails copied!')); }
//   return(
//     <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
//       <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }}><p style={{ fontSize:13,color:'var(--grey-dark)' }}><strong>{subs.length}</strong> subscribers</p>{subs.length>0&&<button onClick={copyAll} style={btn('dark')}>Copy All Emails</button>}</div>
//       <div style={card}><table style={{ width:'100%',borderCollapse:'collapse' }}><thead><tr>{['Email','Subscribed On'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead><tbody>{subs.map((s,i)=>(<tr key={s.id||i}><td style={td}>{s.email}</td><td style={td}>{s.created_at?new Date(s.created_at).toLocaleDateString('en-IN'):'—'}</td></tr>))}</tbody></table>{subs.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No subscribers yet.</p>}</div>
//     </div>
//   );
// }

function SectionNewsletter() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { getNewsletterList().then(d => setSubs(Array.isArray(d) ? d : d?.subscribers || [])).catch(() => {}); }, []);

  function exportAll() {
    const headers = ['Email', 'Subscribed On'];
    const rows = subs.map(s => [
      s.email || '',
      s.created_at ? new Date(s.created_at).toLocaleDateString('en-IN') : '',
    ]);

    const csv = [headers, ...rows]
      .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `aurora-newsletter-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p style={{ fontSize: 13, color: 'var(--grey-dark)' }}>
          <strong>{subs.length}</strong> subscribers
        </p>
        {subs.length > 0 && (
          <button onClick={exportAll} style={btn('dark')}>↓ Export All</button>
        )}
      </div>
      <div style={card}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Email', 'Subscribed On'].map(h => <th key={h} style={th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {subs.map((s, i) => (
              <tr key={s.id || i}>
                <td style={td}>{s.email}</td>
                <td style={td}>{s.created_at ? new Date(s.created_at).toLocaleDateString('en-IN') : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {subs.length === 0 && (
          <p style={{ padding: 32, textAlign: 'center', fontSize: 12, color: 'var(--grey-mid)' }}>
            No subscribers yet.
          </p>
        )}
      </div>
    </div>
  );
}

/* ─── Users ──────────────────────────────────── */
function SectionUsers() {
  const [users,setUsers]=useState([]); const [showForm,setShowForm]=useState(false); const [editing,setEditing]=useState(null); const [saving,setSaving]=useState(false);
  const [form,setForm]=useState({email:'',password:'',role:'admin'});
  const isMobile = useIsMobile();
  const [showPw, setShowPw] = useState(false)
  const [hasSavedPw, setHasSavedPw] = useState(false);
  useEffect(()=>{ getAdminUsers().then(d=>setUsers(Array.isArray(d)?d:[])).catch(()=>{}); },[]);

  // function openNew(){ setEditing(null); setForm({email:'',password:'',role:'admin'}); setShowForm(true); setShowPw(false); }
  // function openEdit(u){ setEditing(u); setForm({email:u.email,password:'',role:u.role||'admin'}); setShowForm(true); setShowPw(false);}
//     function openEdit(u) {
//   setEditing(u);
//   setForm({ email: u.email, password: '', role: u.role || 'admin' });
//   setShowForm(true);
//   setShowPw(false);
//   setHasSavedPw(true); // ← add this
// }
function openEdit(u) {
  setEditing(u);
  setForm({ email: u.email, password: u.plain_password || '', role: u.role || 'admin' });
  setShowForm(true);
  setShowPw(false);
  setHasSavedPw(true);
}
function openNew() {
  setEditing(null);
  setForm({ email: '', password: '', role: 'admin' });
  setShowForm(true);
  setShowPw(false);
  setHasSavedPw(false); // ← add this
}
  // async function handleSave(e){
  //   e.preventDefault(); if(!form.email){alert('Email is required');return;} if(!editing&&!form.password){alert('Password is required');return;} setSaving(true);
  //   try{ if(editing){ const data={role:form.role}; if(form.email!==editing.email)data.email=form.email; if(form.password)data.password=form.password; await updateAdminUser(editing.id,data); setUsers(prev=>prev.map(u=>u.id===editing.id?{...u,email:form.email,role:form.role}:u)); }else{ const created=await createAdminUser(form); setUsers(prev=>[...prev,{id:created.id,email:form.email,role:form.role,created_at:new Date().toISOString()}]); } setShowForm(false); setEditing(null); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);}
  // }
  async function handleSave(e) {
  e.preventDefault();
  if (!form.email) { alert('Email is required'); return; }
  if (!editing && !form.password) { alert('Password is required'); return; }
  setSaving(true);
  try {
    if (editing) {
      const data = { role: form.role };
      if (form.email !== editing.email) data.email = form.email;
      if (form.password) data.password = form.password;
      await updateAdminUser(editing.id, data);
      setUsers(prev => prev.map(u => u.id === editing.id ? { ...u, email: form.email, role: form.role } : u));
      
      // ← ADD THIS
      if (form.password) {
        alert('Password updated successfully.');
      }

    } else {
      const created = await createAdminUser(form);
      setUsers(prev => [...prev, { id: created.id, email: form.email, role: form.role, created_at: new Date().toISOString() }]);
    }
    setShowForm(false);
    setEditing(null);
  } catch(err) {
    alert('Error: ' + err.message);
  } finally {
    setSaving(false);
  }
}

  async function handleDelete(id){ if(!window.confirm('Delete this user?')) return; try{await deleteAdminUser(id);setUsers(prev=>prev.filter(u=>u.id!==id));}catch(err){alert('Error: '+err.message);} }

  if(showForm) return(
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}><button onClick={()=>{setShowForm(false);setEditing(null);}} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button><h2 style={{ fontSize:16,fontWeight:600,color:'var(--dark)' }}>{editing?'Edit User':'Add New User'}</h2></div>
      <form onSubmit={handleSave} style={{ maxWidth:480 }}>
        <div style={{ ...card,display:'flex',flexDirection:'column',gap:18 }}>
          <div><label style={label}>Email Address *</label><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="admin@aurora.in" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div>
  <label style={label}>{editing ? 'New Password (leave blank to keep)' : 'Password *'}</label>
  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
    <input
      type={showPw ? 'text' : 'password'}
      value={form.password}
      onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
      placeholder={editing ? 'Leave blank to keep current' : 'Min 8 characters'}
      style={{ ...inp, paddingRight: 40 }}
      onFocus={e => e.target.style.borderColor = 'var(--dark)'}
      onBlur={e => e.target.style.borderColor = '#e5e7eb'}
    />
    <button
      type="button"
      onClick={() => setShowPw(v => !v)}
      aria-label={showPw ? 'Hide password' : 'Show password'}
      style={{
        position: 'absolute', right: 10, background: 'none', border: 'none',
        cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center',
        color: 'var(--grey-mid)',
      }}
    >
      {showPw
        ? <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
        : <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      }
    </button>
  </div>
</div>
          {/* <div><label style={label}>{editing?'New Password (leave blank to keep)':'Password *'}</label><input type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder={editing?'Leave blank to keep current':'Min 8 characters'} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div> */}
          <div><label style={label}>Role</label><select value={form.role} onChange={e=>setForm(f=>({...f,role:e.target.value}))} style={{ ...inp,cursor:'pointer' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}><option value="admin">Admin</option><option value="superadmin">Super Admin</option><option value="editor">Editor</option></select></div>
          <div style={{ display:'flex',gap:12,paddingTop:8 }}><button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ ...btn('ghost'),flex:1 }}>Cancel</button><button type="submit" disabled={saving} style={{ ...btn('gold'),flex:2,opacity:saving?0.7:1 }}>{saving?'Saving…':editing?'Update User':'Create User'}</button></div>
        </div>
      </form>
    </div>
  );

  return(
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }}><p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{users.length}</strong> admin user{users.length!==1?'s':''}</p><button onClick={openNew} style={btn('gold')}>+ Add User</button></div>
      <div style={card}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%',borderCollapse:'collapse',minWidth: isMobile ? 400 : 'auto' }}>
            <thead><tr>{['Email','Role','Created','Actions'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {users.map(u=>(
                <tr key={u.id} style={{ transition:'background 0.15s' }} onMouseEnter={e=>e.currentTarget.style.background='#f8f9fa'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <td style={td}><div style={{ display:'flex',alignItems:'center',gap:10 }}><div style={{ width:32,height:32,borderRadius:'50%',background:'var(--gold)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'#fff',flexShrink:0 }}>{(u.email?.[0]||'?').toUpperCase()}</div><span style={{ fontSize:13,color:'var(--dark)' }}>{u.email}</span></div></td>
                  <td style={td}><span style={{ fontSize:10,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',padding:'3px 8px',background:u.role==='superadmin'?'#ede9fe':u.role==='editor'?'#e0f2fe':'#dcfce7',color:u.role==='superadmin'?'#5b21b6':u.role==='editor'?'#075985':'#166534' }}>{u.role||'admin'}</span></td>
                  <td style={td}>{u.created_at?new Date(u.created_at).toLocaleDateString('en-IN'):'—'}</td>
                  <td style={td}><div style={{ display:'flex',gap:8 }}><button onClick={()=>openEdit(u)} style={{ padding:'6px 12px',background:'var(--dark)',color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600 }}>Edit</button><button onClick={()=>handleDelete(u.id)} style={{ padding:'6px 12px',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca',cursor:'pointer',fontSize:11,fontWeight:600 }}>Delete</button></div></td>
                </tr>
              ))}
            </tbody>
          </table>
          {users.length===0&&<p style={{ padding:32,textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>No users found.</p>}
        </div>
      </div>
    </div>
  );
}

/* ─── Clients ────────────────────────────────── */
function SectionClients() {
  const [clients,setClients]=useState([]); const [loading,setLoading]=useState(true); const [showForm,setShowForm]=useState(false); const [editing,setEditing]=useState(null); const [saving,setSaving]=useState(false); const [search,setSearch]=useState('');
  const [form,setForm]=useState({name:'',phone:'',email:'',notes:''});
  const [clientOrders,setClientOrders]=useState(null); const [loadingOrders,setLoadingOrders]=useState(false);
  const isMobile = useIsMobile();

  useEffect(()=>{ getClients().then(d=>setClients(Array.isArray(d)?d:[])).catch(()=>{}).finally(()=>setLoading(false)); },[]);

  function getStatus(c){ return Number(c.total_spent)>=500000?'VIP':'Regular'; }
  function initials(name){ return (name||'').split(' ').map(w=>w[0]||'').join('').toUpperCase().slice(0,2); }
  function openWhatsApp(phone){ window.open('https://wa.me/91'+(phone.replace(/\D/g,'').startsWith('91')?phone.replace(/\D/g,''):'91'+phone.replace(/\D/g,'')),'_blank'); }
  function openNew(){ setEditing(null); setForm({name:'',phone:'',email:'',notes:''}); setShowForm(true); }
  function openEdit(c){ setEditing(c); setForm({name:c.name,phone:c.phone,email:c.email||'',notes:c.notes||''}); setShowForm(true); }

  async function viewClientOrders(client){ setLoadingOrders(true); setClientOrders({client,orders:[]}); try{ const all=await getOrders(); const rows=Array.isArray(all)?all:all?.orders||[]; setClientOrders({client,orders:rows.filter(o=>o.customer_phone===client.phone)}); }catch{setClientOrders({client,orders:[]});}finally{setLoadingOrders(false);} }

  async function handleSave(e){ e.preventDefault(); if(!form.name||!form.phone){alert('Name and phone are required');return;} setSaving(true); try{ if(editing){await updateClient(editing.id,form);setClients(prev=>prev.map(c=>c.id===editing.id?{...c,...form}:c));}else{const created=await createClient(form);setClients(prev=>[...prev,{...created,total_spent:0,order_count:0,last_order:null}]);} setShowForm(false); setEditing(null); getClients().then(d=>setClients(Array.isArray(d)?d:[])).catch(()=>{}); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);} }
  async function handleDelete(id){ if(!window.confirm('Delete this client?')) return; await deleteClient(id); setClients(prev=>prev.filter(c=>c.id!==id)); }

  const filtered=clients.filter(c=>(c.name||'').toLowerCase().includes(search.toLowerCase())||(c.phone||'').includes(search));

  return(
    <div style={{ display:'flex',flexDirection:'column',gap: isMobile ? 16 : 32 }}>
      <div style={{ display:'flex',alignItems:'flex-start',justifyContent:'space-between',flexWrap:'wrap',gap:16 }}>
        <div>
          <h1 style={{ fontFamily:'var(--font-display)',fontSize: isMobile ? 'clamp(26px,7vw,36px)' : 'clamp(36px,5vw,52px)',fontWeight:300,color:'var(--dark)',letterSpacing:'-0.02em',lineHeight:1.1,margin:0 }}>Clients</h1>
          <p style={{ fontSize:13,color:'var(--grey-mid)',marginTop:6 }}>Manage customer relationships.</p>
        </div>
        <div style={{ display:'flex',gap:10,alignItems:'center',flexWrap:'wrap' }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search clients…" style={{ ...inp,maxWidth: isMobile ? '100%' : 220,flex: isMobile ? 1 : 'none' }} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/>
          <button onClick={openNew} style={{ display:'flex',alignItems:'center',gap:8,padding:'10px 20px',background:'#fff',border:'1px solid #e5e7eb',cursor:'pointer',fontSize:12,fontWeight:600,color:'var(--dark)',letterSpacing:'0.05em',transition:'border-color 0.2s',borderRadius:8,whiteSpace:'nowrap' }} onMouseEnter={e=>e.currentTarget.style.borderColor='var(--dark)'} onMouseLeave={e=>e.currentTarget.style.borderColor='#e5e7eb'}>+ Add Client</button>
        </div>
      </div>

      {showForm&&(
        <div style={{ background:'#fff',border:'1px solid #e8e4de',borderRadius:12,padding: isMobile ? 20 : 28 }}>
          <h3 style={{ fontFamily:'var(--font-display)',fontSize:18,fontWeight:300,color:'var(--dark)',margin:'0 0 20px' }}>{editing?'Edit Client':'Add New Client'}</h3>
          <form onSubmit={handleSave}>
            <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:14,marginBottom:16 }}>
              {[{name:'name',label:'Full Name *',type:'text'},{name:'phone',label:'Phone *',type:'text'},{name:'email',label:'Email',type:'email'},{name:'notes',label:'Notes',type:'text'}].map(f=>(
                <div key={f.name}><label style={label}>{f.label}</label><input type={f.type} value={form[f.name]} onChange={e=>setForm(prev=>({...prev,[f.name]:e.target.value}))} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
              ))}
            </div>
            <div style={{ display:'flex',gap:12 }}><button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ ...btn('ghost'),flex:1 }}>Cancel</button><button type="submit" disabled={saving} style={{ ...btn('dark'),flex:2,opacity:saving?0.7:1 }}>{saving?'Saving…':editing?'Update Client':'Add Client'}</button></div>
          </form>
        </div>
      )}

      <div style={{ background:'#fff',border:'1px solid #e8e4de',borderRadius:12,overflow:'hidden' }}>
        {/* Header row */}
        {!isMobile&&<div style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr 1fr',padding:'14px 28px',background:'#faf8f5',borderBottom:'1px solid #f3f0eb' }}>{['Client Info','Status','Total Spent','Actions'].map(h=><div key={h} style={{ fontSize:10,letterSpacing:'0.18em',textTransform:'uppercase',fontWeight:600,color:'var(--grey-mid)' }}>{h}</div>)}</div>}

        {loading&&<p style={{ padding:'40px 28px',textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>Loading clients…</p>}
        {!loading&&filtered.length===0&&<p style={{ padding:'48px 28px',textAlign:'center',fontSize:12,color:'var(--grey-mid)' }}>{search?'No clients match your search.':'No clients yet. Click "Add Client" to add one.'}</p>}

        {!loading&&filtered.map((c,i)=>{
          const status=getStatus(c); const isVIP=status==='VIP';
          return(
            <div key={c.id} style={{ display: isMobile ? 'flex' : 'grid',flexDirection: isMobile ? 'column' : undefined,gridTemplateColumns: isMobile ? undefined : '2fr 1fr 1fr 1fr',padding: isMobile ? '16px' : '20px 28px',alignItems: isMobile ? undefined : 'center',borderBottom:i<filtered.length-1?'1px solid #f9f7f4':'none',transition:'background 0.15s',gap: isMobile ? 12 : 0 }} onMouseEnter={e=>e.currentTarget.style.background='#faf8f5'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
              <div style={{ display:'flex',alignItems:'center',gap:14 }}>
                <div style={{ width:40,height:40,borderRadius:'50%',flexShrink:0,background:isVIP?'var(--gold)':'#e8e4de',display:'flex',alignItems:'center',justifyContent:'center' }}><span style={{ fontSize:13,fontWeight:700,color:isVIP?'#fff':'var(--grey-dark)' }}>{initials(c.name)}</span></div>
                <div>
                  <div style={{ fontSize:14,fontWeight:600,color:'var(--dark)',marginBottom:2 }}>{c.name}</div>
                  <div style={{ fontSize:12,color:'var(--grey-mid)',marginBottom:2 }}>{c.phone}</div>
                  <div style={{ fontSize:11,color:'var(--grey-mid)' }}>{Number(c.order_count)} order{Number(c.order_count)!==1?'s':''}</div>
                </div>
              </div>
              <div style={{ display:'flex',alignItems:'center',justifyContent: isMobile ? 'space-between' : undefined,gap:8 }}>
                <span style={{ fontSize:11,fontWeight:600,padding:'4px 14px',borderRadius:20,background:isVIP?'#fef9c3':'#f3f4f6',color:isVIP?'#92400e':'#6b7280',border:'1px solid '+(isVIP?'#fde68a':'#e5e7eb') }}>{status}</span>
                {isMobile&&<div style={{ fontFamily:'var(--font-display)',fontSize:16,fontWeight:300,color:'var(--dark)' }}>₹{Number(c.total_spent).toLocaleString('en-IN')}</div>}
              </div>
              {!isMobile&&<div style={{ fontFamily:'var(--font-display)',fontSize:16,fontWeight:300,color:'var(--dark)' }}>₹{Number(c.total_spent).toLocaleString('en-IN')}</div>}
              <div style={{ display:'flex',alignItems:'center',gap:12,flexWrap:'wrap' }}>
                <button onClick={()=>openWhatsApp(c.phone)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:12,fontWeight:600,color:'#16a34a',padding:0 }}>💬 Chat</button>
                <button onClick={()=>viewClientOrders(c)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:12,color:'var(--gold)',fontWeight:600,padding:0 }}>Orders</button>
                <button onClick={()=>openEdit(c)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:12,color:'var(--grey-mid)',fontWeight:500,padding:0 }}>Edit</button>
                <button onClick={()=>handleDelete(c.id)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:12,color:'#fca5a5',fontWeight:500,padding:0 }}>Delete</button>
              </div>
            </div>
          );
        })}
      </div>

      {!loading&&filtered.length>0&&(
        <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3,1fr)',gap: isMobile ? 10 : 16 }}>
          {[{label:'Total Clients',value:filtered.length},{label:'VIP Clients',value:filtered.filter(c=>getStatus(c)==='VIP').length},{label:'Total Revenue',value:'₹'+filtered.reduce((s,c)=>s+Number(c.total_spent),0).toLocaleString('en-IN')}].map(s=>(
            <div key={s.label} style={{ background:'#fff',border:'1px solid #e8e4de',borderRadius:12,padding: isMobile ? '16px' : '20px 24px' }}>
              <div style={{ fontSize: isMobile ? 9 : 10,letterSpacing:'0.18em',textTransform:'uppercase',color:'var(--grey-mid)',fontWeight:600,marginBottom:8 }}>{s.label}</div>
              <div style={{ fontFamily:'var(--font-display)',fontSize: isMobile ? 22 : 28,fontWeight:300,color:'var(--dark)' }}>{s.value}</div>
            </div>
          ))}
        </div>
      )}

      {clientOrders&&(
        <div onClick={()=>setClientOrders(null)} style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding: isMobile ? 12 : 24 }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:'#fff',borderRadius:12,width:'100%',maxWidth:600,maxHeight:'85vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding:'20px 24px',borderBottom:'1px solid #f3f0eb',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
              <div><div style={{ fontFamily:'var(--font-display)',fontSize:20,fontWeight:300,color:'var(--dark)' }}>{clientOrders.client.name}</div><div style={{ fontSize:12,color:'var(--grey-mid)',marginTop:2 }}>{clientOrders.client.phone}</div></div>
              <button onClick={()=>setClientOrders(null)} style={{ background:'none',border:'none',cursor:'pointer',fontSize:24,color:'var(--grey-mid)',lineHeight:1 }}>×</button>
            </div>
            <div style={{ padding: isMobile ? 16 : 24 }}>
              {loadingOrders&&<p style={{ textAlign:'center',color:'var(--grey-mid)',fontSize:12,padding:'24px 0' }}>Loading orders…</p>}
              {!loadingOrders&&clientOrders.orders.length===0&&<p style={{ textAlign:'center',color:'var(--grey-mid)',fontSize:12,padding:'24px 0' }}>No orders found for this client.</p>}
              {!loadingOrders&&clientOrders.orders.map((o,i)=>{
                const sc={processing:{bg:'#fef9c3',color:'#ca8a04'},shipped:{bg:'#dbeafe',color:'#2563eb'},delivered:{bg:'#dcfce7',color:'#16a34a'},cancelled:{bg:'#fee2e2',color:'#dc2626'}}[(o.status||'').toLowerCase()]||{bg:'#f3f4f6',color:'#6b7280'};
                return(
                  <div key={o.id||o.ref||o.order_ref} style={{ padding:'16px 0',borderBottom:i<clientOrders.orders.length-1?'1px solid #f3f0eb':'none',display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:16 }}>
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap' }}><code style={{ fontSize:12,color:'var(--dark)',fontWeight:600 }}>{o.ref||o.order_ref}</code><span style={{ fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:20,background:sc.bg,color:sc.color }}>{o.status}</span></div>
                    </div>
                    <div style={{ fontFamily:'var(--font-display)',fontSize:18,fontWeight:300,color:'var(--dark)',flexShrink:0 }}>₹{Number(o.total).toLocaleString('en-IN')}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ padding: isMobile ? '0 16px 16px' : '0 24px 24px' }}><button onClick={()=>setClientOrders(null)} style={{ width:'100%',padding:'10px',background:'#f3f4f6',color:'var(--dark)',border:'1px solid #e5e7eb',cursor:'pointer',fontSize:12,fontWeight:600,borderRadius:6 }}>Close</button></div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Brands ─────────────────────────────────── */
function SectionBrands() {
  const [brands, setBrands]   = useState([]);
  const [name, setName]       = useState('');
  const [img, setImg]         = useState('');
  const [file, setFile]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null); // holds brand being edited
  const [editName, setEditName] = useState('');
  const [editImg, setEditImg]   = useState('');
  const [editFile, setEditFile] = useState(null);
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    getBrands().then(setBrands).catch(() => setBrands([]));
  }, []);

  async function handleAdd() {
    if (!name) return alert('Enter brand name');
    let finalImg = img;
    setLoading(true);
    try {
      if (file) {
        const uploadRes = await uploadImage(file);
        if (!uploadRes?.url) throw new Error('Upload failed');
        finalImg = uploadRes.url;
      }
      const res = await createBrand({ name, img: finalImg });
      setBrands(prev => [res, ...prev]);
      setName(''); setImg(''); setFile(null);
    } catch (err) {
      alert('Something went wrong: ' + err.message);
    } finally {
      setLoading(false);
    }
  }

  function openEdit(b) {
    setEditing(b);
    setEditName(b.name);
    setEditImg(b.img || '');
    setEditFile(null);
  }

  async function handleEditSave() {
    if (!editName) return alert('Brand name is required');
    setEditLoading(true);
    try {
      let finalImg = editImg;
      if (editFile) {
        const uploadRes = await uploadImage(editFile);
        if (!uploadRes?.url) throw new Error('Upload failed');
        finalImg = uploadRes.url;
      }
      await updateBrand(editing.id, { name: editName, img: finalImg });
      setBrands(prev =>
        prev.map(b => b.id === editing.id ? { ...b, name: editName, img: finalImg } : b)
      );
      setEditing(null);
    } catch (err) {
      alert('Update failed: ' + err.message);
    } finally {
      setEditLoading(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Delete brand?')) return;
    try {
      await deleteBrand(id);
      setBrands(prev => prev.filter(b => b.id !== id));
    } catch {
      alert('Delete failed');
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

      {/* ── Add Brand ── */}
      <div style={card}>
        <h3 style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--dark)', marginBottom: 16 }}>
          Add Brand
        </h3>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <input
            placeholder="Brand Name *"
            value={name}
            onChange={e => setName(e.target.value)}
            style={{ ...inp, flex: '1 1 160px' }}
            onFocus={e => e.target.style.borderColor = 'var(--dark)'}
            onBlur={e => e.target.style.borderColor = '#e5e7eb'}
          />
          <input
            placeholder="Image URL (optional)"
            value={img}
            onChange={e => setImg(e.target.value)}
            style={{ ...inp, flex: '1 1 160px' }}
            onFocus={e => e.target.style.borderColor = 'var(--dark)'}
            onBlur={e => e.target.style.borderColor = '#e5e7eb'}
          />
          <input
            type="file"
            accept="image/*"
            onChange={e => setFile(e.target.files[0])}
            style={{ ...inp, flex: '1 1 160px' }}
          />
          {(file || img) && (
            <img
              src={file ? URL.createObjectURL(file) : imgSrc(img)}
              alt="preview"
              style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4, border: '1px solid #e5e7eb' }}
            />
          )}
          <button onClick={handleAdd} disabled={loading} style={{ ...btn('gold'), opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Adding…' : '+ Add'}
          </button>
        </div>
      </div>

      {/* ── Edit Modal ── */}
      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 480, padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--dark)', margin: 0 }}>Edit Brand</h3>
              <button onClick={() => setEditing(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: 'var(--grey-mid)', lineHeight: 1 }}>×</button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={label}>Brand Name *</label>
                <input
                  value={editName}
                  onChange={e => setEditName(e.target.value)}
                  style={inp}
                  onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>

              <div>
                <label style={label}>Image</label>
                {(editFile || editImg) && (
                  <img
                    src={editFile ? URL.createObjectURL(editFile) : imgSrc(editImg)}
                    alt="preview"
                    style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 6, border: '1px solid #e5e7eb', marginBottom: 10, display: 'block' }}
                  />
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => setEditFile(e.target.files[0])}
                  style={{ ...inp, marginBottom: 8 }}
                />
                <input
                  placeholder="Or paste image URL"
                  value={editImg}
                  onChange={e => { setEditImg(e.target.value); setEditFile(null); }}
                  style={inp}
                  onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>

              <div style={{ display: 'flex', gap: 12, paddingTop: 8 }}>
                <button
                  onClick={() => setEditing(null)}
                  style={{ ...btn('ghost'), flex: 1 }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleEditSave}
                  disabled={editLoading}
                  style={{ ...btn('gold'), flex: 2, opacity: editLoading ? 0.7 : 1 }}
                >
                  {editLoading ? 'Saving…' : 'Save Changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Brands Table ── */}
      <div style={card}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 300 }}>
            <thead>
              <tr>
                <th style={th}>Image</th>
                <th style={th}>Name</th>
                <th style={th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {brands.map(b => (
                <tr
                  key={b.id}
                  style={{ transition: 'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={td}>
                    {b.img
                      ? <img src={imgSrc(b.img)} alt={b.name} style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }} />
                      : <div style={{ width: 50, height: 50, background: '#f3f4f6', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>🛍️</div>
                    }
                  </td>
                  <td style={{ ...td, fontWeight: 500 }}>{b.name}</td>
                  <td style={td}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => openEdit(b)}
                        style={{ padding: '6px 12px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(b.id)}
                        style={{ padding: '6px 12px', background: '#fef2f2', color: 'var(--red)', border: '1px solid #fecaca', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {brands.length === 0 && (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: 32, fontSize: 12, color: 'var(--grey-mid)' }}>
                    No brands yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* ─── Testimonials ───────────────────────────── */
function SectionTestimonials() {
  const [items,setItems]=useState([]); const [showForm,setShowForm]=useState(false); const [editing,setEditing]=useState(null); const [saving,setSaving]=useState(false);
  const emptyForm={ name:'',location:'',stars:5,text:'',active:1,sort_order:0 };
  const [form,setForm]=useState(emptyForm);
  const isMobile = useIsMobile();

  useEffect(()=>{ getAdminTestimonials().then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{}); },[]);

  function openNew(){ setEditing(null); setForm(emptyForm); setShowForm(true); }
  function openEdit(t){ setEditing(t); setForm({name:t.name||'',location:t.location||'',stars:t.stars||5,text:t.text||'',active:+t.active,sort_order:t.sort_order||0}); setShowForm(true); }

  async function handleSave(e){ e.preventDefault(); if(!form.name||!form.text){alert('Name and text required');return;} setSaving(true); try{ if(editing){await updateTestimonial(editing.id,form);setItems(prev=>prev.map(t=>t.id===editing.id?{...t,...form}:t));}else{const created=await createTestimonial(form);setItems(prev=>[...prev,created]);} setShowForm(false); setEditing(null); }catch(err){alert('Error: '+err.message);}finally{setSaving(false);} }
  async function handleToggle(id,current){ const newVal=current?0:1; await toggleTestimonial(id,newVal); setItems(prev=>prev.map(t=>t.id===id?{...t,active:newVal}:t)); }
  async function handleDelete(id){ if(!window.confirm('Delete this testimonial?')) return; await deleteTestimonial(id); setItems(prev=>prev.filter(t=>t.id!==id)); }

  if(showForm) return(
    <div>
      <div style={{ display:'flex',alignItems:'center',gap:16,marginBottom:24 }}><button onClick={()=>{setShowForm(false);setEditing(null);}} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--grey-dark)',fontSize:14 }}>← Back</button><h2 style={{ fontSize:16,fontWeight:600,color:'var(--dark)' }}>{editing?'Edit Testimonial':'Add Testimonial'}</h2></div>
      <form onSubmit={handleSave} style={{ maxWidth:600 }}>
        <div style={{ ...card,display:'flex',flexDirection:'column',gap:16 }}>
          <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:12 }}>
            <div><label style={label}>Client Name *</label><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Priya S." style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
            <div><label style={label}>Location</label><input value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} placeholder="e.g. Mumbai" style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          </div>
          <div><label style={label}>Rating</label><div style={{ display:'flex',gap:8 }}>{[1,2,3,4,5].map(n=>(<button key={n} type="button" onClick={()=>setForm(f=>({...f,stars:n}))} style={{ width:36,height:36,border:`2px solid ${form.stars>=n?'var(--gold)':'#e5e7eb'}`,background:form.stars>=n?'#fffbeb':'#fff',cursor:'pointer',fontSize:18 }}>★</button>))}</div></div>
          <div><label style={label}>Review Text *</label><textarea value={form.text} onChange={e=>setForm(f=>({...f,text:e.target.value}))} rows={5} style={{ ...inp,resize:'vertical' }} placeholder="Write the client's review here…" onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
          <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:12 }}>
            <div><label style={label}>Sort Order</label><input type="number" value={form.sort_order} onChange={e=>setForm(f=>({...f,sort_order:Number(e.target.value)}))} style={inp} onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'}/></div>
            <div><label style={label}>Visibility</label><button type="button" onClick={()=>setForm(f=>({...f,active:f.active?0:1}))} style={{ width:'100%',padding:'10px',border:`2px solid ${form.active?'#16a34a':'var(--grey)'}`,background:form.active?'#dcfce7':'#fff',color:form.active?'#16a34a':'var(--grey-dark)',fontSize:12,fontWeight:600,cursor:'pointer' }}>{form.active?'✓ Visible on site':'Hidden'}</button></div>
          </div>
          <div style={{ display:'flex',gap:12,paddingTop:8 }}><button type="button" onClick={()=>{setShowForm(false);setEditing(null);}} style={{ ...btn('ghost'),flex:1 }}>Cancel</button><button type="submit" disabled={saving} style={{ ...btn('gold'),flex:2,opacity:saving?0.7:1 }}>{saving?'Saving…':editing?'Update':'Add Testimonial'}</button></div>
        </div>
      </form>
    </div>
  );

  return(
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <p style={{ fontSize:13,color:'var(--grey-dark)',margin:0 }}><strong>{items.length}</strong> testimonials · <span style={{ color:'#16a34a' }}><strong>{items.filter(t=>+t.active===1).length}</strong> active</span></p>
        <button onClick={openNew} style={btn('gold')}>+ Add Testimonial</button>
      </div>
      <div style={{ display:'grid',gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(320px,1fr))',gap:16 }}>
        {items.map(t=>(
          <div key={t.id} style={{ ...card,display:'flex',flexDirection:'column',gap:12,opacity:+t.active?1:0.55 }}>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start' }}>
              <div style={{ display:'flex',gap:3 }}>{Array.from({length:5}).map((_,i)=><svg key={i} width={12} height={12} viewBox="0 0 24 24" fill={i<t.stars?'var(--gold)':'#e5e7eb'}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>)}</div>
              <span style={{ fontSize:9,fontWeight:700,padding:'3px 8px',background:+t.active?'#dcfce7':'#f3f4f6',color:+t.active?'#16a34a':'#6b7280' }}>{+t.active?'LIVE':'HIDDEN'}</span>
            </div>
            <p style={{ fontSize:13,color:'var(--grey-dark)',fontStyle:'italic',lineHeight:1.7,margin:0,flexGrow:1 }}>"{t.text}"</p>
            <div style={{ paddingTop:10,borderTop:'1px solid #ede9e3' }}>
              <div style={{ fontSize:11,fontWeight:700,color:'var(--dark)',letterSpacing:'0.1em',textTransform:'uppercase' }}>{t.name}</div>
              {t.location&&<div style={{ fontSize:11,color:'var(--grey-mid)' }}>{t.location}</div>}
            </div>
            <div style={{ display:'flex',gap:8,flexWrap:'wrap' }}>
              <button onClick={()=>handleToggle(t.id,+t.active)} style={{ padding:'6px 12px',fontSize:11,fontWeight:600,cursor:'pointer',border:'none',background:+t.active?'#fef3c7':'#dcfce7',color:+t.active?'#92400e':'#166534' }}>{+t.active?'Hide':'Show'}</button>
              <button onClick={()=>openEdit(t)} style={{ padding:'6px 12px',fontSize:11,fontWeight:600,cursor:'pointer',background:'var(--dark)',color:'#fff',border:'none' }}>Edit</button>
              <button onClick={()=>handleDelete(t.id)} style={{ padding:'6px 12px',fontSize:11,fontWeight:600,cursor:'pointer',background:'#fef2f2',color:'var(--red)',border:'1px solid #fecaca' }}>Del</button>
            </div>
          </div>
        ))}
        {items.length===0&&<p style={{ fontSize:12,color:'var(--grey-mid)',padding:32,gridColumn:'1/-1' }}>No testimonials yet.</p>}
      </div>
    </div>
  );
}

function SectionLeads() {
  const [leads, setLeads] = useState([]);
  const isMobile = useIsMobile();

  useEffect(() => {
    getLeads().then(d => setLeads(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  async function handleDelete(id) {
    if (!window.confirm('Delete this lead?')) return;
    await fetch(`${BASE_URL}/admin_panel.php?section=leads&id=${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('aurora_admin_token') || ''}` }
    });
    setLeads(prev => prev.filter(l => l.id !== id));
  }

  // function copyAll() {
  //   navigator.clipboard.writeText(leads.map(l => `${l.name}, ${l.email}, ${l.phone}`).join('\n'))
  //     .then(() => alert('Copied!'));
  // }

  function copyAll() {
  const headers = ['Name', 'Email', 'Phone', 'Date'];
  const rows = leads.map(l => [
    l.name || '',
    l.email || '',
    l.phone || '',
    l.created_at ? new Date(l.created_at).toLocaleDateString('en-IN') : '',
  ]);

  const csv = [headers, ...rows]
    .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `aurora-leads-${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <p style={{ fontSize: 13, color: 'var(--grey-dark)', margin: 0 }}>
          <strong>{leads.length}</strong> lead{leads.length !== 1 ? 's' : ''} collected
        </p>
        {leads.length > 0 && (
          <button onClick={copyAll} style={btn('dark')}>Export All</button>
        )}
      </div>
      <div style={card}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 500 }}>
            <thead>
              <tr>
                {['Name', 'Email', 'Phone', 'Date', ''].map(h => (
                  <th key={h} style={th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {leads.map(l => (
                <tr key={l.id}
                  style={{ transition: 'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={td}><strong>{l.name}</strong></td>
                  <td style={td}>{l.email}</td>
                  <td style={td}>
                    {l.phone
                      ? <a href={`https://wa.me/91${l.phone.replace(/\D/g,'')}`} target="_blank" rel="noreferrer"
                          style={{ color: '#16a34a', fontWeight: 600, textDecoration: 'none' }}>
                          {l.phone}
                        </a>
                      : '—'}
                  </td>
                  <td style={td}>
                    {l.created_at ? new Date(l.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—'}
                  </td>
                  <td style={td}>
                    <button onClick={() => handleDelete(l.id)}
                      style={{ padding: '5px 10px', background: '#fef2f2', color: 'var(--red)', border: '1px solid #fecaca', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                      Del
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {leads.length === 0 && (
            <p style={{ padding: 32, textAlign: 'center', fontSize: 12, color: 'var(--grey-mid)' }}>
              No leads yet. The popup will collect them automatically.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}